{
  "app": {
    "title": "Dispatcher console",
    "loading": "Loading…",
    "signOut": "Sign out",
    "offline": "Offline · reconnecting…",
    "offlineHint": "The map and the queue are not updating. The console is reconnecting on its own.",
    "newBuild": "A new version of the console is ready. Reloading keeps you signed in.",
    "newBuildLater": "Later",
    "reload": "Reload",
    "stopped": "Something went wrong and the console stopped. Reloading keeps you signed in."
  },
  "signIn": {
    "title": "Sign in",
    "company": "Company",
    "companyHint": "Your company code",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "working": "Signing in…"
  },
  "queue": {
    "title": "Queue",
    "empty": "Nothing waiting.",
    "reference": "Ref",
    "pickup": "Pickup",
    "state": "State",
    "waiting": "Waiting",
    "driver": "Driver",
    "minutes": "{{minutes}} min",
    "dueIn": "in {{minutes}} min",
    "automation": "Automatic",
    "needsAttention": "Needs you",
    "needsAttentionHelp": "The search gave up, or a booking is nearly due with nobody going.",
    "byHand": "By hand",
    "searching": "Looking for a driver",
    "offeredTo": "With {{name}}, try {{attempt}}",
    "offeredToMany": "With {{count}} drivers at the rank",
    "takeOver": "Take over",
    "handBack": "Hand back",
    "stage": {
      "Rank": "the rank",
      "Zone": "the zone",
      "ParentZones": "a wider zone",
      "Radius": "nearby"
    },
    "needing_one": "{{count}} needs you",
    "needing_other": "{{count}} need you",
    "showOnMap": "Show on the map — {{name}}"
  },
  "order": {
    "newOrder": "New order",
    "phone": "Phone",
    "editPhone": "Change the number",
    "noPhone": "no number",
    "name": "Name",
    "pickup": "Pickup",
    "destination": "Destination",
    "notes": "Notes",
    "take": "Dispatch order",
    "taking": "Dispatching…",
    "taken": "Order {{reference}} taken",
    "known": "Known caller · {{count}} rides",
    "savedAddresses": "Saved addresses",
    "blocked": "This customer is blocked",
    "pickupRequired": "Choose an address from the list",
    "detail": "Order {{reference}}",
    "history": "History",
    "close": "Close",
    "cancel": "Cancel order",
    "destinationNotFound": "That destination could not be found",
    "rating": "Rating",
    "ratingStars_one": "{{count}} star",
    "ratingStars_other": "{{count}} stars",
    "farePaid": "Paid",
    "fareEstimated": "Estimated fare",
    "scheduledFor": "For later (optional)",
    "title": "Order",
    "keysHint": "How to take an order from the keyboard",
    "keysHelp": {
      "intro": "A whole order can be taken without the mouse:",
      "tab": "to the next field",
      "arrows": "in the suggestions under an address — choose; [Enter] takes it",
      "letter": "an address with entrances (e.g. “4 entrances”) — after [Enter] their letters appear under the field; press the one you need:",
      "letterDoor": "entrance {{letter}}",
      "letterKeep": "[Enter] or [Esc] — no entrance, the car goes to the building",
      "letterNew": "another letter — written in as a new entrance",
      "letterKey": "Letter",
      "scope": "only while in an address field — the Search in buttons:",
      "space": "switch a requirement on or off — several if needed; [Tab] moves between them",
      "spaceKey": "Space",
      "enter": "take the order",
      "esc": "clear the form",
      "after": "Once an order is taken, the cursor is already in the pickup address, so the next one starts right there."
    },
    "notesPlaceholder": "Anything the driver should know",
    "holdCaller": "Hold the caller",
    "customerPhone": "Customer phone",
    "driver": "Driver",
    "call": "Call",
    "couldNotCall": "The call could not be placed.",
    "noDriverPhone": "no number",
    "scope": {
      "label": "Search in",
      "town": "Town",
      "nearby": "Nearby",
      "wider": "Wider",
      "anywhere": "Anywhere",
      "shortcut": "Alt+{{key}}",
      "nothingIn": "Nothing found in {{level}}.",
      "auto": "Auto",
      "nothing": "Nothing found.",
      "widen": "Search {{level}}",
      "autoAbout": "Automatic: the town first, and further only when nothing is found"
    },
    "mapMissing": "The map search is not answering — only the firm's and the caller's own addresses are shown.",
    "knownNamed": "Known customer: {{name}} · {{count}} rides",
    "replay": "Replay",
    "replayHelp": "Watch this order's journey on the map, from the moment a driver took it",
    "declineReason": {
      "too_far": "too far",
      "finishing_shift": "finishing the shift",
      "break": "on a break",
      "vehicle_problem": "a problem with the car",
      "other": "another reason",
      "no_response": "did not answer in time"
    },
    "reason": {
      "declinedBecause": "declined — {{why}}",
      "declined": "declined",
      "offerExpired": "the offer ran out",
      "reassigned": "taken away from the driver",
      "claimed": "first of several to accept",
      "noCars": "no car was free",
      "needsHuman": "automatic dispatch asked for a dispatcher",
      "atRisk": "pre-booking at risk: no car yet",
      "takenByHand": "taken over by hand",
      "automaticResumed": "handed back to automatic dispatch",
      "streetRide": "taken in the street",
      "cancelledByRider": "Cancelled by the passenger: {{why}}",
      "cancelledByRiderOwnReason": "Cancelled by the passenger, for one of the firm’s own reasons"
    },
    "driverRating": "Driver's rating",
    "entrances": {
      "count_one": "{{count}} entrance",
      "count_other": "{{count}} entrances",
      "label": "Entrance:",
      "keys": "a letter picks it · Enter keeps the building",
      "waiting": "awaiting approval",
      "waitingAbout": "Placed or moved by a dispatcher or a driver; used already, and waiting for the administrator",
      "reported": "reported",
      "reportedAbout": "A driver said this spot is wrong; the administrator has not answered yet",
      "unplaced": "new entrance",
      "unplacedAbout": "Nobody has placed this entrance yet: the car goes to the building, and the driver will be asked to remember the spot"
    },
    "numbers": {
      "count_one": "{{count}} number",
      "count_other": "{{count}} numbers"
    }
  },
  "assign": {
    "title": "Assign a driver",
    "reassign": "Reassign",
    "refresh": "Refresh",
    "more": "{{count}} more",
    "fewer": "Fewer",
    "assign": "Assign",
    "assigning": "Assigning…",
    "holding": "Holding",
    "noneAvailable": "No drivers available nearby",
    "stale": "{{seconds}}s ago",
    "staleHint": "Position is stale — the car may no longer be there"
  },
  "map": {
    "title": "Live vehicles",
    "unavailable": "The map is unavailable right now",
    "callSign": "Short number",
    "arriving": "Arriving",
    "arrivingIn": "in about {{minutes}} min",
    "vehicle": "Vehicle",
    "state": "State",
    "onOrder": "On order",
    "home": {
      "sectionTitle": "Where every map opens",
      "sectionHelp": "Pan and zoom until the map shows your city the way you want to see it, then save. The desk and the passenger app open here — the passenger's own position first, this when the phone cannot say — and so does the zone editor until the first zone is drawn; after that it opens on the zones themselves. Address search looks around this point first too, so a street typed without its town is found in yours.",
      "search": "Find a place by name — a city, a street — and press Enter",
      "notFound": "Nothing found for “{{query}}”.",
      "couldNotSearch": "Could not search for that.",
      "useThisView": "Use this view",
      "clearChoice": "Forget my choice",
      "unsaved": "The map has moved.",
      "saved": "Saved. Every map now opens here.",
      "figures": "{{latitude}}, {{longitude}} · zoom {{zoom}}",
      "source": {
        "set": "You chose this view — or it was set from the firm's town when the firm was created.",
        "derived": "Guessed from your largest zone. Move the map to change it.",
        "deployment": "Nothing chosen yet: this is the installation's default. Move the map to your city and save.",
        "nowhere": "Nothing chosen yet, so the map opens over Europe. Find your city and save.",
        "moved": "Moved. Save to make every map open here, or discard."
      },
      "sourceWord": {
        "set": "Chosen on the Map page",
        "derived": "Taken from your largest zone"
      },
      "guide": {
        "title": "Where you are",
        "body": "Move the map to your city as you want to see it; every map will open here. Leave it and it is guessed from your zones later."
      }
    },
    "toggleOnBreak": "Show or hide the cars on a break",
    "allowedCars": "May drive",
    "headingHome": "Heading home",
    "headingTo": "Heading to {{address}}",
    "headingHomeHint": "Offered only jobs whose destination takes him nearer where he is heading."
  },
  "settings": {
    "title": "Dispatch settings",
    "close": "Close",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved",
    "couldNotLoad": "These settings could not be loaded. You may not have permission to change them.",
    "couldNotSave": "These settings could not be saved.",
    "unitSeconds": "seconds",
    "unitDrivers": "drivers",
    "autoDispatch": "Send cars automatically",
    "autoDispatchHelp": "Orders find their own driver instead of waiting for a dispatcher to assign one. Dispatchers can still assign by hand at any time.",
    "dispatchIntervalSeconds": "Check the queue every",
    "dispatchIntervalSecondsHelp": "How often waiting orders are looked at. Lower is faster for the passenger; there is rarely a reason to go above ten.",
    "offerTimeoutSeconds": "A driver has to answer within",
    "offerTimeoutSecondsHelp": "After this the offer is taken back and passed to the next driver. Too short and drivers cannot reach the phone; too long and the passenger waits on somebody who is not looking.",
    "maxDispatchAttempts": "Try at most",
    "maxDispatchAttemptsHelp": "How many drivers may be offered one order before the search gives up.",
    "searchTimeoutSeconds": "Give up searching after",
    "searchTimeoutSecondsHelp": "A time limit as well as a driver limit, so an order nobody was available to refuse does not wait forever. Set to 0 to rely on the driver limit alone.",
    "whenNoCarsFound": "When no car is found",
    "whenNoCarsFoundHelp": "What happens once the search gives up.",
    "noCarsAction": {
      "TellTheRider": "Tell the passenger and cancel",
      "EscalateToDispatcher": "Leave it for a dispatcher"
    },
    "retryAfterSeconds": "Ask the passenger to try again after",
    "retryAfterSecondsHelp": "Shown to them when the ride is cancelled. Long enough that the fleet has changed, short enough that they are still nearby.",
    "unitMetres": "metres",
    "unitMetresPerMinute": "metres a minute",
    "unitMinutes": "minutes",
    "unitDays": "days",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeStage": "Remove this step",
    "addStage": "Use this step",
    "groupLadder": "Who gets asked, and in what order",
    "groupLadderHelp": "An order is offered outward in steps. Each step is asked in full before the next begins, and a step with nobody in it is skipped rather than waited on.",
    "dispatchRadiiMetres": "Widening circles",
    "dispatchRadiiMetresHelp": "Distances from the pickup, in metres, tried in turn once the zones are exhausted. Separate them with commas. The last one is as far as you are willing to send a car.",
    "stage": {
      "Rank": "The rank",
      "RankHelp": "The rank covering the pickup. The driver at the front of the queue is asked first and alone; everybody else at that rank is then asked together.",
      "Zone": "The zone",
      "ZoneHelp": "Drivers standing inside the zone the pickup is in.",
      "ParentZones": "The zones above it",
      "ParentZonesHelp": "Each larger zone in turn — the district, then the city.",
      "Radius": "Widening circles",
      "RadiusHelp": "Anyone within each distance in turn. This is the step that works when no zones have been drawn."
    },
    "groupRanks": "Ranks",
    "groupRanksHelp": "A rank is a zone drivers queue at. The order of arrival decides who is asked first, which is the rule ranks have always run on.",
    "rankFirstOfferSeconds": "The front cab has",
    "rankFirstOfferSecondsHelp": "How long the driver at the head of the queue gets the order to themselves. They have waited longest and are owed first refusal, so this is longer than the window everybody else gets.",
    "rankRestOfferSeconds": "Everybody else then has",
    "rankRestOfferSecondsHelp": "When the front cab does not take it, the rest of the rank is asked all at once and the first to accept wins. Shorter, because a passenger is waiting.",
    "rankExitMarginMetres": "A car keeps its place within",
    "rankExitMarginMetresHelp": "How far outside the rank a car may drift before it loses its place in the queue. A parked car's position wanders by tens of metres, and without this it would rejoin at the back every minute.",
    "groupFairness": "Fairness",
    "groupFairnessHelp": "Nearest is not the whole answer. These adjust how far away a driver is treated as being, in metres, so the reason can be explained to them: refusing pushes you back, waiting pulls you forward.",
    "acceptancePenaltyMetres": "Refusing everything costs",
    "acceptancePenaltyMetresHelp": "How much further away a driver who never accepts is treated as being. Keep it modest: punishing refusals hard teaches drivers to accept and then cancel, which is worse for the passenger.",
    "idleBonusMetresPerMinute": "Each minute waiting earns",
    "idleBonusMetresPerMinuteHelp": "How much closer waiting on shift makes a driver look, so a quiet corner of the city is not a dead end.",
    "maxFairnessAdjustmentMetres": "Never move a driver more than",
    "maxFairnessAdjustmentMetresHelp": "The cap on the two settings above. Past this, distance wins whatever anybody's record looks like — which is what stops a car being sent across the city while a closer one waits.",
    "acceptanceWindowDays": "Count the last",
    "acceptanceWindowDaysHelp": "How much history counts toward a driver's acceptance rate. Offers another driver won first are not counted against anybody.",
    "roadRankingCandidates": "Check road distance for",
    "roadRankingCandidatesHelp": "How many of the closest drivers are checked by road rather than in a straight line, so the one across the river is not treated as nearby. Each check is billed by the mapping provider, so keep this small.",
    "groupPreBookings": "Bookings for later",
    "groupPreBookingsHelp": "A ride booked for tomorrow morning should not sit in tonight's queue, and it must not be left until the pickup time to find a car.",
    "preBookingLeadMinutes": "Start looking",
    "preBookingLeadMinutesHelp": "How long before the pickup time the search for a driver begins. Too late and the car arrives late; too early and a driver sits unpaid outside an address.",
    "preBookingEscalateMinutes": "Warn the office",
    "preBookingEscalateMinutesHelp": "How long before the pickup an unfilled booking is flagged in the queue. An airport run at four in the morning with nobody going is the case this exists for.",
    "loading": "Loading…",
    "unsaved_one": "{{count}} change not saved",
    "unsaved_other": "{{count}} changes not saved",
    "discard": "Discard",
    "cancel": "Cancel",
    "groupSending": "Sending cars",
    "groupSendingHelp": "The timings that decide how fast a passenger hears back, and how long a driver is given to answer.",
    "preBookingsEnabled": "Take orders for later",
    "preBookingsEnabledOn": "The order form has a “For later” box, and orders booked for later are listed apart until they fall due.",
    "preBookingsEnabledOff": "Every order is for now: the order form has no “For later” box, and the passenger app cannot book ahead. Orders already booked for later are still served."
  },
  "admin": {
    "title": "Company settings",
    "sections": "Settings sections",
    "tab": {
      "dispatch": "Dispatch",
      "zones": "Zones and ranks",
      "tariffs": "Prices",
      "surcharges": "Night, holidays",
      "telephony": "Telephones",
      "duty": "Duty and rates",
      "reports": "Reports",
      "branding": "Branding",
      "import": "Customers from your previous system",
      "fleet": "Fleet",
      "simulation": "Simulation"
    }
  },
  "simulation": {
    "title": "Simulating {{city}}",
    "hint": "This company is not real. Its drivers are processes, its orders arrive on their own, and its callers were made up. Nothing here exists on a production server.",
    "notRunning": "This company is marked as simulated, but nothing is running for it. Check the server log: the usual cause is a company code the simulation has no city for.",
    "couldNotChange": "Could not change the simulation.",
    "drivers": "Drivers",
    "running": "Running",
    "runningHint": "Turned off, every simulated driver is signed off rather than left frozen on the map.",
    "activeDrivers": "Drivers on shift",
    "activeDriversHint": "Out of fifty. They sign on, report their positions and take work like anybody else.",
    "outsideCity": "Drivers out of town",
    "outsideCityHint": "How many roam outside {{city}}, to real places nearby.",
    "acceptProbability": "How often a driver accepts",
    "acceptProbabilityHint": "Between 0 and 1. Below one so that refusals happen and the offer cascade is exercised.",
    "work": "Work",
    "ordersPerHour": "Orders an hour",
    "ordersPerHourHint": "Booked by the seeded callers, from the addresses they usually use. Zero stops new ones; rides already running finish.",
    "callsPerHour": "Calls an hour",
    "callsPerHourHint": "Some answered, some left to the missed queue. Zero stops them.",
    "createOrders": "Take five orders now",
    "callerLabel": "Who is calling",
    "caller": {
      "known": "A known caller",
      "unknown": "An unknown number",
      "withheld": "Withheld number"
    },
    "ring": "Ring the desk",
    "reset": "Reset",
    "noAudio": "A simulated call produces the screen-pop and the call record. There is no audio and the softphone will not ring — that half needs the real telephone system.",
    "counters": "Since it started",
    "ordersCreated": "{{count}} order(s) taken",
    "ridesCompleted": "{{count}} ride(s) completed",
    "ridesNoShow": "{{count}} passenger(s) never came out",
    "offersAccepted": "{{count}} offer(s) accepted",
    "offersDeclined": "{{count}} offer(s) declined",
    "callsRung": "{{count}} call(s) put through",
    "callsMissed": "{{count}} call(s) missed",
    "fleet": "On shift now",
    "away": "out of town",
    "column": {
      "callSign": "No.",
      "driver": "Driver",
      "plate": "Car",
      "phase": "Doing",
      "order": "Ride"
    },
    "phase": {
      "SignedOff": "Off duty",
      "Roaming": "Driving about",
      "Considering": "Looking at an offer",
      "ToPickup": "On the way",
      "WaitingAtPickup": "Waiting outside",
      "OnRide": "Carrying a passenger",
      "Break": "On a break",
      "Retiring": "Finishing, then off"
    }
  },
  "tariffs": {
    "history": "Price history",
    "historyHelp": "Every version, with the dates it applied. Past versions are read-only: the fares they produced are what people were charged, and changing them would make old receipts wrong.",
    "none": "No prices have been set yet.",
    "code": "Tariff",
    "from": "From",
    "to": "Until",
    "inForce": "In force",
    "fromTheStart": "From the start",
    "introduce": "New prices",
    "introduceHelp": "This adds a new version rather than editing the current one. The version in force closes at the moment the new one begins, so rides already priced keep the prices they were priced at.",
    "introduceAction": "Bring these prices into force",
    "displayName": "Name",
    "displayNameHelp": "What the office calls this tariff. Never used for anything but reading.",
    "category": "Vehicle class",
    "categoryHelp": "Every class is priced the same unless you choose one: an estate or a van can be priced on its own. Features such as pets or a wheelchair cost nothing extra.",
    "everyClass": "Every class",
    "baseFare": "Starting price",
    "baseFareHelp": "Charged the moment the meter starts, whatever the distance.",
    "perKilometre": "Per kilometre",
    "perKilometreHelp": "Charged for every kilometre driven. Both this and the per-minute price apply, which is how a real meter works.",
    "perMinute": "Per minute",
    "perMinuteHelp": "Charged for every minute of the journey, so a car stuck in traffic is not working for nothing.",
    "perWaitingMinute": "Per minute waiting",
    "perWaitingMinuteHelp": "Charged while the driver waits at the pickup, after the free minutes below.",
    "freeWaitingMinutes": "Free waiting",
    "freeWaitingMinutesHelp": "Minutes of waiting given away before the meter starts. Not generosity — it stops a passenger being charged for a driver who arrived early.",
    "minimumFare": "Minimum fare",
    "minimumFareHelp": "The floor, however short the ride. Without one, drivers refuse short journeys.",
    "roundingIncrement": "Round to",
    "roundingIncrementHelp": "What the total is rounded to — 0.10 for the nearest ten stotinki, so a driver is not counting coppers in the dark.",
    "currency": "Currency",
    "currencyHelp": "The firm's own currency, already filled in. Change it only for a tariff that is priced in another — three letters, such as EUR.",
    "effectiveFrom": "Starting",
    "effectiveFromHelp": "When these prices begin. Leave empty to start immediately."
  },
  "fees": {
    "title": "Cancellation and no-show fees",
    "intro": "What the firm charges for a ride that never happened. Zero means it charges nothing, which is where every firm starts. Unlike a tariff, these are ordinary numbers rather than versions: the amount is written onto the ride the moment it is incurred, so changing it here can never reach a cancellation that has already happened.",
    "cancellation": "Cancellation fee ({{currency}})",
    "cancellationHelp": "Charged when a passenger calls off a ride a driver was already on the way to — not one still waiting for a car, and not one a driver has been offered but has not answered yet. Set it and the passenger app names the amount in its warning before the tap; leave it at zero and the app says only that the firm may charge.",
    "noShow": "No-show fee ({{currency}})",
    "noShowHelp": "Charged when the car reached the address and nobody appeared. Usually higher than a cancellation: a driver who waited outside a door has lost more than one who was turned round on the way.",
    "bothOff": "Both are zero, so nothing is charged for a cancellation or a no-show. The passenger app keeps its general warning that the firm may charge."
  },
  "payment": {
    "title": "How rides are paid",
    "intro": "Drivers are not asked how a ride was paid, so unless something says otherwise every completed ride is recorded as this. It is what fills the cash column in the shift book: before it, every ride landed under \"unrecorded\" and the takings half of the report said nothing at all.",
    "fallback": "Record a ride as",
    "fallbackHelp": "Applied when a ride is completed and nothing was said about payment. If a driver ever does report how a ride was paid, his answer is kept instead.",
    "method": {
      "Cash": "Cash",
      "Card": "Card",
      "Account": "On account",
      "none": "Do not record anything"
    },
    "recordingNothing": "Nothing will be recorded, so completed rides go on counting as unrecorded in the shift book. Choose this if your cars take card as often as cash — an assumption that is wrong half the time is worse than an admitted gap.",
    "neverBackwards": "Rides that have already finished are left exactly as they are. Nobody was asked how they were paid, so they keep their empty column rather than being given an answer after the fact."
  },
  "surcharges": {
    "rules": "Night and holiday rates",
    "rulesHelp": "A night or holiday tariff with prices of its own — the start, the kilometre, the minute and the waiting, each set separately, as on the meter — or an uplift of a percentage and an amount on top of the standard tariff.",
    "noRules": "No night or holiday tariffs set.",
    "calendar": "Holiday calendar",
    "calendarHelp": "Which dates count as holidays for this firm. Bulgarian holidays are not Irish ones, so this is yours alone.",
    "noHolidays": "No holidays are set.",
    "kind": {
      "TimeBand": "At certain hours",
      "Holiday": "On holidays"
    },
    "code": "Short name",
    "codeHelp": "A stable name used in reports, for example night.",
    "name": "Shown as",
    "nameHelp": "What appears on a passenger's receipt. Your words, in your language.",
    "hours": "Between",
    "hoursHelp": "In your own local time. An end earlier than the start means it runs through midnight, which is what a night rate normally does.",
    "until": "Until",
    "days": "On these days",
    "day": {
      "Monday": "Mon",
      "Tuesday": "Tue",
      "Wednesday": "Wed",
      "Thursday": "Thu",
      "Friday": "Fri",
      "Saturday": "Sat",
      "Sunday": "Sun"
    },
    "percentField": "Add a percentage",
    "percentFieldHelp": "A percentage of what the meter made. Taken against the metered fare, so two rules of ten percent add twenty rather than twenty-one.",
    "amountField": "Add a fixed amount",
    "amountFieldHelp": "A flat sum, in the tariff's currency. You can set both this and a percentage.",
    "active": "In use",
    "activeHelp": "Turn a rule off without losing it.",
    "saveRule": "Save this tariff",
    "cancelEdit": "Cancel",
    "edit": "Edit",
    "remove": "Remove",
    "band": "{{from}} to {{to}}",
    "onHolidays": "On holidays",
    "percent": "+{{percent}}%",
    "amount": "+{{amount}}",
    "everyYear": "every year on {{date}}",
    "holidayName": "Name",
    "holidayNameHelp": "What the day is called.",
    "holidayDate": "Date",
    "holidayDateHelp": "For a date that recurs, the year is ignored.",
    "recurring": "Same date every year",
    "recurringHelp": "Christmas recurs; Orthodox Easter does not. A date that moves has to be entered each year.",
    "saveHoliday": "Save this date",
    "kindLabel": "Applies",
    "kindLabelHelp": "On certain hours of certain days, or on the dates in your holiday calendar.",
    "addRule": "Add tariff",
    "editRule": "Edit tariff",
    "addHoliday": "Add a date",
    "editHoliday": "Edit this date",
    "uplift": "Prices",
    "allDays": "Every day",
    "inactive": "Not in use",
    "confirmRemoveRuleTitle": "Remove this rate?",
    "confirmRemoveRule": "{{name}} will be removed. Fares it already raised stay as they were charged. This cannot be undone.",
    "confirmRemoveHolidayTitle": "Remove this date?",
    "confirmRemoveHoliday": "{{name}} will no longer count as a holiday. This cannot be undone.",
    "modeLabel": "How it charges",
    "modeHelp": "Prices of its own replace the standard tariff's for the whole ride — how a night tariff is set in Bulgaria. An uplift adds a percentage or an amount on top of the standard tariff's prices.",
    "mode": {
      "Rates": "Prices of its own",
      "Uplift": "Uplift on the standard"
    },
    "ownPrices": "start {{base}} · {{perKilometre}}/km"
  },
  "zones": {
    "tree": "Zones",
    "treeHelp": "Your map of the city: areas, with ranks inside them. The same zones decide what a ride costs and who gets offered it. They nest three levels deep.",
    "overview": "On the map",
    "overviewAbout": "Every zone, where it is. Click one, its name, or its chip below to edit it.",
    "overviewHelp": "Each zone in its own colour, never the same as the zone it is in or the one beside it. Squares are areas, discs are ranks. A zone that is switched off is faded.",
    "expand": "Make the map the whole page",
    "shrink": "Make the map small again",
    "snapHelp": "Click near a neighbouring zone's corner or edge and the corner lands exactly on it, so the two meet with no gap. Their corners show as small rings while your pointer is over the map.",
    "keepCorners": "Keep neighbours' corners shown",
    "keepCornersHelp": "Shown while your pointer is over the map, which is enough when editing a zone that exists. When drawing a new one, some people prefer to see the neighbours' corners all the time, since those are the places a new corner is aimed at.",
    "keepCornersHint": "What this switch is for",
    "none": "No zones have been drawn.",
    "rank": "rank",
    "circleOf": "circle, {{radius}} m",
    "polygonOf": "boundary, {{corners}} corners",
    "charges": "+{{percent}}% +{{amount}}",
    "add": "Add a zone",
    "editing": "Editing {{name}}",
    "code": "Short name",
    "codeHelp": "A stable name used in reports, for example airport.",
    "name": "Shown as",
    "nameHelp": "What the office calls it.",
    "hue": "Colour",
    "hueHelp": "How the zone is drawn on the maps. Automatic keeps it apart from the zones it is inside, beside or touching; pick one when two neighbours still look alike.",
    "hueAutomatic": "Automatic",
    "hueNumber": "Colour {{number}}",
    "parent": "Inside",
    "parentHelp": "The larger zone this sits in. Leave empty for a top-level zone such as the city itself.",
    "noParent": "Nothing — this is a top-level zone",
    "kind": {
      "Area": "An area",
      "Rank": "A rank"
    },
    "shape": {
      "Circle": "A circle",
      "Polygon": "A drawn boundary"
    },
    "radius": "Radius",
    "radiusHelp": "How far the circle reaches from its centre. Drag the slider, or type the metres.",
    "radiusValue": "{{metres}} metres",
    "clickCentre": "Click the map to place the centre, or drag it.",
    "clickCorners": "Click the map to add corners, in order around the edge. Click a side to add a corner on it, and drag a corner to move it.",
    "undo": "Undo",
    "clearCorners": "Start again",
    "surchargePercent": "Add a percentage",
    "surchargePercentHelp": "A percentage added to fares touching this zone. Leave at zero for a zone that only organises the map.",
    "surchargeAmount": "Add a fixed amount",
    "surchargeAmountHelp": "A flat sum added to fares touching this zone — the airport supplement, usually.",
    "appliesTo": "Charged when",
    "appliesToHelp": "Which end of the journey has to be in this zone. Charged once even when both are.",
    "trigger": {
      "Pickup": "Picking up here",
      "Destination": "Dropping off here",
      "Either": "Either end"
    },
    "active": "In use",
    "activeHelp": "Turn a zone off without deleting the rides it priced.",
    "save": "Save this zone",
    "kindLabel": "This zone is",
    "kindLabelHelp": "A rank keeps a queue of the drivers parked in it, and the front of that queue is offered a job first.",
    "shapeLabel": "Shape",
    "shapeLabelHelp": "A circle is three numbers and covers a rank or a terminal. Draw a boundary when a circle would take in the wrong side of a street.",
    "ranks": "Ranks",
    "ranksHelp": "The places drivers wait for work. A rank keeps a queue in the order cars arrived at it, and the front of that queue is offered a job first.",
    "noRanks": "No ranks have been drawn.",
    "addRank": "Add a rank",
    "off": "Off",
    "columnZone": "Zone",
    "columnSurcharge": "Surcharge",
    "confirmRemoveTitle": "Remove this zone?",
    "confirmRemove": "{{name}} will be removed, and every ride it priced or dispatched keeps what it was given. This cannot be undone."
  },
  "addressSearch": {
    "levels": "Three levels",
    "levelsHelp": "Each is a circle or a drawn area, and each takes in the ones above it. The desk starts every order on the town.",
    "columnLevel": "Level",
    "level": {
      "Town": "Town",
      "Nearby": "Nearby",
      "Wider": "Wider"
    },
    "levelAbout": {
      "Town": "Where the desk searches by default. Draw the town itself.",
      "Nearby": "The villages the firm drives to. Searched together with the town when the dispatcher switches to it.",
      "Wider": "Further still, such as the airport in the next city. Left undrawn, this level searches everywhere."
    },
    "notDrawn": "Not drawn",
    "anywhere": "Not drawn: searches everywhere",
    "draw": "Draw",
    "clear": "Clear",
    "editing": "{{level}}: where the search looks",
    "copyFrom": "Start from a zone",
    "copyFromHelp": "Copies the zone's shape. Changing the zone later does not change this.",
    "copyChoose": "Choose a zone…",
    "shapeHelp": "A circle is quickest. Draw an area when a circle would take in places the firm does not serve.",
    "radiusHelp": "How far from the centre an address may be.",
    "overview": "On the map",
    "overviewAbout": "The levels drawn so far. Click one to change it.",
    "nothingDrawn": "Nothing drawn yet. The desk searches everywhere, nearest first, and shows no switch until the town is drawn.",
    "confirmClearTitle": "Clear this level?",
    "confirmClear": "The desk will no longer search {{level}} as its own level.",
    "confirmClearWider": "The desk’s widest level will search everywhere again.",
    "overviewHelp": "Each level in its own colour. The legend names them; click one to change it.",
    "save": "Save",
    "rider": {
      "title": "Passenger app search",
      "help": "Who finds an address for a passenger typing one in the app, and names the place under the pin. The firm’s own addresses always come first, whichever is chosen. The desk and the driver app always search our maps: Google’s terms allow its results only on Google’s map, which the passenger app uses and they do not.",
      "supplier": "Search with",
      "about": {
        "OwnMaps": "Our own maps of Bulgaria, the same as the desk.",
        "Google": "Google, for streets our maps do not have."
      },
      "googleUnavailable": "Google cannot be chosen: this installation has no Google key.",
      "googleFallenBack": "This installation has no Google key, so the passenger app is searching our maps until one is added.",
      "suppliers": {
        "OwnMaps": "Our maps",
        "Google": "Google"
      }
    }
  },
  "prebookings": {
    "title": "Booked for later",
    "dueIn": "in {{minutes}} min",
    "atRisk": "No driver",
    "atRiskHelp": "The search has run out of time and nobody is going. Place this by hand."
  },
  "telephony": {
    "title": "Telephone system",
    "enabled": "This company has a telephone system",
    "enabledHelp": "Turn this on once the PBX is installed and reachable. Until then no call arrives at the console and nothing is logged.",
    "groupCalls": "Calls",
    "groupCallsHelp": "How the console reaches the PBX to see calls arriving and to place them. Without this there is no screen-pop and no click-to-call.",
    "groupExtensions": "Dispatcher telephones",
    "groupExtensionsHelp": "The database on the PBX where dispatchers’ telephones live. Without it nobody can be given a telephone, and the ones already signed in stop working within a few minutes.",
    "groupNumbers": "Numbers and lines",
    "groupNumbersHelp": "Which numbers reach this company, and which line calls go out on.",
    "groupRecording": "Recording",
    "groupRecordingHelp": "Whether calls are recorded, and for how long they are kept. Recording a customer is a legal decision this company makes, not a setting we choose for you.",
    "pbxBaseUrl": "PBX address",
    "pbxBaseUrlHelp": "Where the PBX answers, including the port. This must never be reachable from the internet — a PBX open to the world places international calls at your expense.",
    "pbxAriUsername": "PBX username",
    "pbxAriUsernameHelp": "The account the console uses to watch and place calls.",
    "pbxAriSecret": "PBX password",
    "pbxWebSocketUrl": "Telephone address for browsers",
    "pbxWebSocketUrlHelp": "Where a dispatcher’s browser connects to make and take calls. On the platform it is the firm’s own address with pbx as its second word — shown greyed in the empty box — and the platform passes it on to the PBX over the tunnel.",
    "pbxRealtimeHost": "Extension database address",
    "pbxRealtimeHostHelp": "The PBX’s own machine. It has to be the PBX’s own, because the PBX reads it every time a telephone signs in — a copy elsewhere makes the telephones depend on this office’s internet.",
    "pbxRealtimePort": "Port",
    "pbxRealtimePortHelp": "Usually 5432.",
    "pbxRealtimeDatabase": "Database name",
    "pbxRealtimeDatabaseHelp": "The database the PBX reads its telephones from.",
    "pbxRealtimeUsername": "Database username",
    "pbxRealtimeUsernameHelp": "An account that may add and remove telephones. Nothing else.",
    "pbxRealtimePassword": "Database password",
    "secretStored": "A password is stored. Leave this blank to keep it.",
    "secretNotStored": "No password is stored yet.",
    "inboundNumbers": "Numbers that reach this company",
    "inboundNumbersHelp": "Separated by commas. A call is matched to this company by the number it was made to, so every number the company answers on belongs here.",
    "outboundLineStrategy": "Calls go out on",
    "outboundLineStrategyHelp": "Which line a call-back uses, and so which of your numbers the customer sees ringing.",
    "lineStrategy": {
      "ReturnPath": "The line the call came in on",
      "FirmOrder": "Our lines, in the order below"
    },
    "outboundOrder": "Lines for outgoing calls",
    "outboundOrderHelp": "The first free line is used. When it is busy the call goes out on the next, and so on down the list. Lines not in the list are never used for calls you place.",
    "outboundOrderEmpty": "Choose at least one line below, or the setting cannot be saved.",
    "outboundOrderNoLines": "This company has no lines yet. Add them under Lines below, then choose their order here.",
    "outboundOrderAdd": "Use this line",
    "outboundOrderRemove": "Stop using this line",
    "recordCalls": "Record calls",
    "recordCallsHelp": "An announcement plays at the start of every recorded call. Recording somebody without telling them is not a feature, it is a fine.",
    "recordingRetentionDays": "Keep recordings for",
    "recordingRetentionDaysHelp": "After this they are deleted. There is no “keep everything”: recordings of a customer are personal data, and an archive with no end date is a problem waiting for the first person who asks what you hold on them.",
    "groupBlocked": "Blocked callers",
    "groupBlockedHelp": "What happens when a customer marked as blocked rings the firm.",
    "turnBlockedCallersAway": "Turn blocked callers away",
    "turnBlockedCallersAwayHelp": "A blocked customer hears busy and no telephone rings. The call stays in the call log as refused. If the system is unreachable the call rings as usual.",
    "recordWithoutAnnouncement": "Record without the announcement",
    "recordWithoutAnnouncementHelp": "Granted to this company by the platform operator. Callers hear nothing before the call; tell them some other way, as agreed.",
    "recordWithoutAnnouncementOnRequest": "Available on request from the platform operator, once you have agreed how callers are told some other way. Until then the announcement plays.",
    "groupCallFlow": "How a caller waits for a car",
    "groupCallFlowHelp": "What happens to somebody after a dispatcher has taken their order. Leave this alone unless the prompt recordings and the hold extension have been set up on the PBX.",
    "callFlow": "When the order has been taken",
    "callFlowHelp": "The classic way is what most companies run: the dispatcher answers, takes the order and that is the end of the call.",
    "flow": {
      "Classic": "Nothing — the call simply ends",
      "HoldAndAnnounce": "Hold the caller and tell them which car is coming",
      "RingBackOnly": "Hang up and ring them back with the car"
    },
    "flowHelp": {
      "Classic": "No hold music, no announcement, no ring-back. Nothing below applies.",
      "HoldAndAnnounce": "The dispatcher parks the caller on hold music. When a driver accepts the job, the caller hears the car number and how long it will be. A caller you must not park — on a SIM, or when the lines are full — is rung back instead.",
      "RingBackOnly": "Nobody waits on the line. The dispatcher takes the order, says the company will ring back, and hangs up; the customer is rung back with the car number once a driver accepts. This is the version that costs you no lines."
    },
    "trunkChannels": "Simultaneous calls the internet line carries",
    "trunkChannelsHelp": "What the telecom sold you, which nothing here can measure. Get this wrong upwards and callers hear a busy tone; get it wrong downwards and you hold fewer people than you could.",
    "trunkChannelsKeptFree": "Always keep free for new callers",
    "trunkChannelsKeptFreeHelp": "Somebody waiting for a car occupies a line the whole time. Without this, a company holding four callers on a four-call line is a company nobody can ring.",
    "maxHeldOnTrunk": "That leaves room for {{count}} caller waiting at once.",
    "maxHeldOnTrunk_other": "That leaves room for {{count}} callers waiting at once.",
    "simLinePattern": "SIM lines are named",
    "simLinePatternHelp": "Calls arriving on a line whose name starts with this came in over a SIM. Leave empty if this company has no SIMs. The call log’s line column shows what the names actually are.",
    "maxHeldOnSims": "Callers held on SIMs at once",
    "maxHeldOnSimsHelp": "A SIM is one call. While somebody waits on it, that number is busy to everybody who dials it — which is why none is the usual answer, and a SIM caller is rung back instead.",
    "holdTimeoutSeconds": "Hold a caller for at most",
    "holdTimeoutSecondsHelp": "After this, whatever you chose below happens. Three minutes is the usual answer.",
    "waitingReminderSeconds": "Say “still looking” every",
    "waitingReminderSecondsHelp": "Played over the hold music so somebody waiting knows the line is alive. Zero switches it off; otherwise it is twenty seconds at the shortest.",
    "whenHoldExpires": "When they have waited that long",
    "whenHoldExpiresHelp": "Neither of these is comfortable. Hanging up is only acceptable if you actually ring back, and handing them to a dispatcher is only acceptable if one is free.",
    "holdExpiry": {
      "RingBackWhenCarFound": "Say you will ring back, hang up, and do it",
      "ReturnToDispatchers": "Ring the dispatchers again"
    },
    "ringBackWhenCallerHangsUp": "Ring back somebody who gave up waiting",
    "ringBackWhenCallerHangsUpHelp": "They still want the taxi they ordered. Off is for a company that would rather not ring a number nobody asked them to ring.",
    "ringBackAttempts": "Try a ring-back",
    "ringBackAttemptsHelp": "How many times to ring somebody who does not answer. Zero switches ring-backs off entirely, in every mode.",
    "ringBackRetrySeconds": "Wait between attempts",
    "ringBackRetrySecondsHelp": "Long enough that a second ring is not the same ring again.",
    "announceArrivalTime": "Say how many minutes",
    "announceArrivalTimeHelp": "Off, the announcement says the car is on its way and names no time. A company whose cars queue behind one bridge may prefer that to promising five minutes twice a day.",
    "announcementRepeats": "Play the announcement",
    "announcementRepeatsHelp": "Twice is usual: a car number heard once over a telephone is a car number half-heard.",
    "holdMusicClass": "Hold music",
    "holdMusicClassHelp": "The music-on-hold class as the PBX names it. Every installation has one called “default”.",
    "promptSet": "Recordings folder",
    "promptSetHelp": "Where this company’s recorded prompts live on the PBX, under its sounds folder. A different voice, or a different language, is a different folder and nothing else.",
    "unitChannels": "calls",
    "unitCallers": "callers",
    "unitAttempts": "times",
    "unitTimes": "times",
    "test": "Test the connection",
    "testing": "Testing…",
    "couldNotTest": "The connection could not be tested.",
    "doorCalls": "Calls",
    "doorExtensions": "Dispatcher telephones",
    "reachable": "Working",
    "result": {
      "NotConfigured": "Not set up",
      "Unauthorised": "Wrong username or password",
      "Unreachable": "No answer",
      "Reachable": "Working"
    },
    "groupRinging": "Ringing and desks",
    "groupRingingHelp": "How long the telephones ring, when a caller left on hold rings their dispatcher again, and how desk phones are shared.",
    "ringSeconds": "Ring time",
    "ringSecondsHelp": "How long the dispatchers’ telephones ring before the caller hears the apology and the call is missed.",
    "holdRecallSeconds": "Time on hold before it rings back",
    "holdRecallSecondsHelp": "A caller on hold rings the dispatcher who put them there after this long, and again after the same time if nobody answers — so nobody is forgotten.",
    "deskPhonesBelongTo": "Desk phones belong to",
    "deskPhonesBelongToHelp": "A desk: whoever signs in at it has its phone, and says which desk at sign-in. A dispatcher: you give each person their phone below.",
    "belongToDesk": "A desk",
    "belongToDispatcher": "A dispatcher",
    "callDistribution": "How calls reach the desks",
    "callDistributionHelp": "All at once: every desk rings and the first to lift it has it. Taking turns: one call to a desk, the next call to the next desk, round and round. The first free desk: the first desk in the list below when it is free, the second only when the first is busy, and so on. A dispatcher in the browser with no desk comes after every desk.",
    "distributionAllAtOnce": "All desks at once",
    "distributionTakeTurns": "The desks take turns",
    "distributionInOrder": "The first free desk",
    "deskBusyWhen": "A desk is busy when",
    "deskBusyWhenHelp": "A desk phone takes one call. With several on a desk: is the desk busy only when every phone on it is, or as soon as its dispatcher is on any of them? Either way, when every desk is busy the free phones still ring.",
    "busyAllPhones": "Every phone is busy",
    "busyAnyPhone": "Any phone is busy",
    "nextDesk": "When a desk does not answer",
    "nextDeskHelp": "It can ring alone until the ring time runs out, or bring in the next desk after a while, then the one after it. The desk already ringing goes on ringing.",
    "nextDeskNever": "It rings alone",
    "nextDeskToo": "The next desk rings too",
    "nextDeskAfter": "The next desk rings after",
    "nextDeskAfterHelp": "How long the desk rings alone before the next one joins in. Keep it shorter than the ring time, or the next desk never rings.",
    "deskPhoneServer": "Address desk phones register to",
    "deskPhoneServerHelp": "The telephone system as the office network reaches it — its address, with :port if it is not 5060. Shown beside each new desk phone’s password."
  },
  "calls": {
    "ringing": "Ringing",
    "newCaller": "New caller",
    "newCallerHelp": "Nobody the office has spoken to before. Take the order and the address is saved for next time.",
    "noName": "No name on file",
    "noAddresses": "No saved addresses yet.",
    "withheld": "Number withheld",
    "dialledLine": "To {{number}}",
    "blocked": "This customer is blocked.",
    "take": "Take this call",
    "dismiss": "Dismiss",
    "known": "Known caller",
    "savedAddresses": "Saved addresses",
    "driversSay": "Drivers: ★ {{stars}} ({{count}})",
    "noShows_one": "{{count}} no-show",
    "noShows_other": "{{count}} no-shows"
  },
  "softphone": {
    "title": "Telephone",
    "off": "No telephone",
    "connecting": "Connecting…",
    "registered": "Ready · {{extension}}",
    "reconnecting": "Reconnecting…",
    "failed": "The telephone could not connect.",
    "offline": "Not connected",
    "devices": "Headset",
    "microphone": "Microphone",
    "speaker": "Speaker",
    "systemDefault": "System default",
    "incoming": "Call from {{from}}",
    "answer": "Answer",
    "reject": "Reject",
    "calling": "Calling {{to}}…",
    "cancel": "Cancel",
    "hangUp": "Hang up",
    "mute": "Mute",
    "hold": "Hold",
    "keypad": "Keypad",
    "transfer": "Transfer",
    "transferTo": "Transfer to",
    "dismiss": "Dismiss",
    "lostOnReload": "The page was reloaded during a call, so the call was lost. The caller will need ringing back.",
    "waitingForCar": "Waiting for a car",
    "parked": "They are on hold. They will be told which car is coming as soon as a driver takes the job.",
    "parkOnSim": "This line is a SIM. Tell the caller you will ring them back, then hang up — the system will do it once a car is found.",
    "willRingBack": "Tell the caller you will ring back with the car, then hang up.",
    "couldNotPark": "The caller could not be put on hold.",
    "idle": "Nobody on the line.",
    "onACall": "On a call",
    "ringing": "ringing",
    "callingOut": "calling",
    "answerFailed": "The call was not answered — check the microphone. The caller is still ringing.",
    "microphoneAccess": {
      "allow": "Allow the microphone",
      "recheck": "Check again",
      "askable": "This telephone has not been given the microphone yet. Allow it now, so the first call of the shift is not the one that asks.",
      "refused": "The microphone is blocked for this site, so calls cannot carry your voice. Allow it in the browser's own settings — the padlock beside the address — then check again.",
      "missing": "No microphone was found on this computer. Plug one in, then check again: calls will connect and the caller will hear nothing.",
      "unknown": "Whether this telephone can use the microphone is unknown. Allow it now rather than finding out on a call."
    },
    "onDesk": "{{desk}} · {{extension}}",
    "deskTakenOver": "{{name}} sat down at {{desk}}. Its telephone rings for them now.",
    "deskUnreachableFallback": "{{desk}} cannot be reached. Calls ring this browser until it is back.",
    "deskUnreachable": "{{desk}} cannot be reached, and nothing else rings for you. Check its cable, or let this browser ring from the menu.",
    "couldNotHold": "The caller could not be put on hold.",
    "ringsOnDesk": "Calls ring {{desk}} ({{extension}}). Answer on the handset.",
    "secondCall": "second call",
    "answerSecond": "Answer, hold the first",
    "heldHere": "On hold here: {{peer}}",
    "resume": "Resume",
    "answerOn": "Answer on",
    "answerOnBrowser": "This browser",
    "answerOnDesk": "Desk phone",
    "ringBrowserWhenDeskUnreachable": "Ring this browser when the desk phone cannot be reached",
    "ringDeskWhenBrowserUnreachable": "Ring the desk phone when this browser is closed",
    "ringOther": "Ring the other telephone"
  },
  "held": {
    "title": "Waiting for a car",
    "ofLines": "{{held}} of {{max}} lines holding",
    "waitingFor": "waiting {{time}}"
  },
  "missed": {
    "title": "To ring back",
    "waiting": "{{count}} waiting",
    "show": "Show",
    "hide": "Hide",
    "callBack": "Call back",
    "clear": "Clear",
    "confirmClear": "Clear it",
    "reason": "Reason",
    "reasonPlaceholder": "Other reason…",
    "failed": "That did not work. Somebody else may have taken it.",
    "none": "Nothing to ring back.",
    "agoMinutes_one": "{{count}} min ago",
    "agoMinutes_other": "{{count}} min ago",
    "agoHours_one": "{{count}} h ago",
    "agoHours_other": "{{count}} h ago",
    "agoDays_one": "{{count}} day ago",
    "agoDays_other": "{{count}} days ago",
    "reasons": {
      "served": "Already served",
      "wrongNumber": "Wrong number",
      "noAnswer": "No answer",
      "notNeeded": "No longer needed"
    },
    "otherReason": "Other reason"
  },
  "duty": {
    "title": "Days worked, and what they cost",
    "intro": "The firm’s income is a count of days worked multiplied by a rate. These settings say what counts as a day; the rate below says what one costs, and every change to it is a new version so a rise in March cannot reprice February.",
    "minimumMinutes": "Minimum for a chargeable day",
    "minimumMinutesHelp": "Minutes on duty across a whole local day before it counts. Sessions add up; three twenty-five-minute runs are a day. Zero means any sign-on counts.",
    "weekStartsOn": "Week starts on",
    "weekStartsOnHelp": "When the weekly cap resets, and the first column of every weekly view.",
    "silenceTimeout": "End a silent shift after",
    "silenceTimeoutHelp": "Minutes a shift may report no position before the system signs it off. A parked car still reports every forty-five seconds, so silence means the app is closed or the battery is flat. Shorter, and a driver in an underground car park is signed off while working.",
    "maxShiftHours": "Never longer than",
    "maxShiftHoursHelp": "Hours. The ceiling on one shift, applied by the sweep and again by the report, so a forgotten sign-off costs one wrong day rather than one wrong quarter.",
    "driversSeeTheirDues": "Drivers see their own dues in the app",
    "driversSeeTheirDuesHelp": "A driver who has watched the figure add up all month is not surprised by it at the end of one. Turning this off refuses the request, not just the screen. Never another driver’s figures, either way.",
    "driversSeeTheirTakings": "Drivers also see what their car took",
    "driversSeeTheirTakingsHelp": "Rides, distance and fares by cash, card and account, beside their dues — the same figures as the shift book. Off by default, because the office’s figure is the one that counts. Needs the dues switched on.",
    "days": {
      "Sunday": "Sunday",
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday"
    },
    "introduce": "Set a new rate",
    "introduceHelp": "This adds a version rather than changing the current one. Days already worked keep the rate that was in force when they were worked — which is what makes a settled month still explainable next year.",
    "introduceAction": "Bring into force",
    "appliesTo": "Applies to",
    "appliesToHelp": "Everybody, or one driver on a different deal.",
    "everybody": "Everybody",
    "dailyAmount": "Daily rate",
    "dailyAmountHelp": "What one chargeable day costs, in {{currency}}.",
    "weeklyCap": "Weekly cap",
    "weeklyCapHelp": "The most any single week may come to, in {{currency}}. Leave empty for no cap.",
    "noCap": "no cap",
    "effectiveFrom": "In force from",
    "fromTheStart": "From the start",
    "effectiveFromHelp": "Midnight on this date, in the firm’s own timezone.",
    "effectiveTo": "Until",
    "inForce": "in force",
    "endDeal": "End this deal",
    "history": "Every rate this firm has had",
    "historyHelp": "Kept so a settled month can still be explained. Nothing here is ever edited; a change is a new row.",
    "unitHours": "hours",
    "none": "No rate has been set yet.",
    "cancel": "Cancel"
  },
  "reports": {
    "sections": "Reports",
    "loading": "Working…",
    "export": "Export CSV",
    "total": "Total of {{count}} shown",
    "tab": {
      "shiftBook": "Shift book",
      "demand": "When and where",
      "service": "Service"
    },
    "period": {
      "label": "Period",
      "thisWeek": "This week",
      "lastWeek": "Last week",
      "thisMonth": "This month",
      "lastMonth": "Last month",
      "lastThreeMonths": "Last three months",
      "custom": "Custom",
      "from": "From",
      "to": "To",
      "showing": "{{from}} – {{to}} · {{zone}}"
    },
    "sources": {
      "Phone": "Telephone",
      "RiderApp": "Rider app",
      "Web": "Web",
      "Api": "Integration",
      "Street": "Off the street"
    },
    "shiftBook": {
      "views": "Shift book views",
      "view": {
        "fleet": "Every driver",
        "grid": "Grid"
      },
      "driver": "Driver",
      "filter": "Find a driver",
      "filterHint": "name or short number",
      "daysWorked": "Days worked",
      "daysCharged": "Days charged",
      "hours": "Hours",
      "hoursOnDuty": "Hours on duty",
      "hoursOnBreak": "Hours on break",
      "break": "Break",
      "sessions": "Sessions",
      "day": "Day",
      "chargeable": "Counts",
      "cost": "Cost ({{currency}})",
      "charged": "Charged ({{currency}})",
      "outstanding": "Outstanding ({{currency}})",
      "outstandingAllTime": "Outstanding, all time",
      "amountOwed": "Owed for this period",
      "rides": "Rides",
      "takings": "Taken ({{currency}})",
      "cashCard": "cash {{cash}} · card {{card}}",
      "settled": "Settled",
      "markPaid": "Mark paid",
      "yes": "Yes",
      "left": "has left",
      "belowMinimum": "below the minimum",
      "unratedDays": "{{count}} with no rate",
      "unratedDaysHint": "Days that counted but had no rate in force. Shown rather than charged at zero.",
      "unpriced": "{{count}} with no fare",
      "unpricedHint": "Completed rides carrying no fare figure. Counted rather than treated as zero.",
      "noRate": "This firm has not set what a day costs, so the money columns are empty. Days and hours are still counted.",
      "openSettings": "Set a rate",
      "mixedCurrency": "This period straddles a change of currency, so the total adds two of them together.",
      "backToFleet": "Back to every driver",
      "weeks": "By week",
      "weekStarting": "Week starting",
      "uncapped": "Before the cap ({{currency}})",
      "cap": "Cap",
      "capApplied": "capped",
      "partialWeek": "the period cuts this week short",
      "ending": {
        "SweptOff": "the system ended this shift",
        "Capped": "never signed off — capped",
        "Running": "still running",
        "EndedByOffice": "the office ended this shift"
      },
      "payments": "Payments",
      "showPayments": "Show payments",
      "noPayments": "Nothing recorded yet.",
      "paidAt": "Paid",
      "amount": "Amount",
      "note": "Note",
      "reverse": "Reverse",
      "reverseReason": "Why was this payment wrong?",
      "attribution": "A ride counts on the day it finished; a duty day counts on the day the shift started. A night shift therefore lands in two different places — the money follows the meter and the day follows the man.",
      "outstandingIsAllTime": "Charged and taken follow the period on screen. Outstanding is all time.",
      "paidInPeriod": "Paid ({{currency}})",
      "paidInPeriodShort": "Paid in this period",
      "daysChargedSub_one": "{{shown}} charged",
      "daysChargedSub_other": "{{shown}} charged",
      "driverCount_one": "{{shown}} driver",
      "driverCount_other": "{{shown}} drivers",
      "driversOwe_one": "{{shown}} driver owes",
      "driversOwe_other": "{{shown}} drivers owe",
      "paidSub": "{{amount}} paid in the period",
      "breakSub": "{{hours}} on break",
      "outstandingAllTimeIn": "Outstanding, all time ({{currency}})",
      "filterPlaceholder": "Find a driver — name or short number",
      "byDay": "By day",
      "nobodyWorked": "Nobody was on duty in this period.",
      "noMatch": "No driver here matches that.",
      "paymentsHidden": "Not fetched until you ask for them.",
      "reverseTitle": "Reverse this payment",
      "reverseConfirm": "Reverse it",
      "cancel": "Cancel",
      "notOnDuty": "He was not on duty in this period."
    },
    "grid": {
      "worked": "{{day}}: {{hours}} on duty",
      "notWorked": "{{day}}: not worked",
      "legend": "Darker is longer. A pale outlined cell is a day below the {{minutes}}-minute minimum, which counts as worked and costs nothing. A blank cell was not worked at all.",
      "cell": "{{driver}}, {{day}}: {{hours}} on duty"
    },
    "demand": {
      "orders": "Orders",
      "completed": "Completed",
      "unfilled": "Found no car",
      "busiest": "Busiest hour: {{day}} at {{hour}}.",
      "byHour": "By hour of the day",
      "cell": "{{day}} {{hour}}: {{orders}} orders, {{unfilled}} found no car",
      "unfilledLegend": "A cell with an outline contains at least one order nobody could fill.",
      "byZone": "By zone",
      "zone": "Zone",
      "outsideEveryZone": "Outside every zone",
      "cancellations": "Cancellations",
      "cancelledBy": "Called off by",
      "afterAssignment": "A car was on its way",
      "afterACarWasSent": "yes",
      "beforeACarWasSent": "no",
      "sources": "How the work arrived",
      "source": "Source"
    },
    "service": {
      "orders": "Orders",
      "medianToAssign": "Median to find a car",
      "worstToAssign": "Worst to find a car",
      "medianToArrive": "Median to arrive",
      "worstToArrive": "Worst to arrive",
      "noCarRate": "Found no car",
      "byHour": "Waiting, by hour of the day",
      "byHourAlt": "Median time to find a car and to arrive, for each hour of the day",
      "assignAt": "{{hour}}:00 — {{wait}} to find a car, {{orders}} orders",
      "arriveAt": "{{hour}}:00 — {{wait}} to arrive, {{orders}} orders",
      "drivers": "Who answers",
      "offered": "Offered",
      "accepted": "Accepted",
      "declined": "Declined",
      "timedOut": "Timed out",
      "acceptanceRate": "Acceptance",
      "completed": "Rides",
      "acceptanceIsDispatchs": "This is the same acceptance rate dispatch weighs its offers with, not a second one. Offers another driver won first, and offers a dispatcher pulled back, do not count against anybody.",
      "ratings": "What riders thought",
      "noRatings": "Nobody has rated a ride in this period.",
      "averageOf": "Average {{average}} from {{count}} riders.",
      "noDrivers": "No offers went out in this period.",
      "noCancellations": "Nothing was called off in this period.",
      "journeys": "Journeys",
      "journeysHelp": "This driver's orders in the same period, each one ready to replay"
    },
    "clients": {
      "clients": "Clients",
      "ofOrders": "from {{shown}} orders",
      "newClients": "New clients",
      "returning": "Returning",
      "topTenShare": "Top ten clients' share of rides",
      "topTenSpendSub": "{{share}} of what was paid",
      "show": "Top",
      "all": "All",
      "byRides": "Most rides",
      "bySpend": "Most spent",
      "costly": "Costly clients",
      "costlyHint": "Called off with a car already on its way, or not there when it arrived.",
      "costlyDetail": "{{after}} after a car was sent · {{noShows}} no-shows · {{cancelled}} called off in all",
      "failed": "Clients we failed",
      "failedHint": "Orders of theirs nobody could fill.",
      "failedDetail": "{{orders}} orders, {{rides}} rides",
      "noClients": "Nobody ordered in this period.",
      "noCostly": "Nobody called off a car on its way, and nobody was a no-show.",
      "noFailed": "Every order in this period found a car.",
      "lost": "Gone quiet",
      "lostHint": "Rode between {{from}} and {{to}}, and have not ordered since.",
      "noLost": "Everybody who rode in the previous stretch has ordered again.",
      "client": "Client",
      "ridesThen": "Rides then",
      "spentThen": "Spent then",
      "lastRide": "Last ride",
      "loyalty": "How often they rode",
      "ridesInPeriod": "Rides in the period",
      "bandOpen": "{{min}} or more",
      "bandNone": "None finished",
      "bandOne": "One",
      "bandRange": "{{min}} to {{max}}",
      "everyone": "Every client",
      "filter": "Find a client",
      "filterHint": "name or number",
      "orders": "Orders",
      "rides": "Rides",
      "cancelled": "Called off",
      "unfilled": "Found no car",
      "spent": "Spent",
      "averageFare": "Average fare",
      "payment": "Cash / card / account",
      "source": "Phone / app",
      "since": "Client since",
      "new": "New",
      "paymentSplit": "{{cash}} / {{card}} / {{account}}",
      "unrecorded": "{{amount}} unrecorded",
      "sourceSplit": "{{phone}} / {{app}}",
      "attribution": "Every figure follows the day the order was asked for, as on When and where. The shift book follows the day a ride finished, so a ride across midnight at the edge of the period can sit in different months on the two.",
      "anonymous": "{{shown}} orders were taken with no number and belong to nobody here.",
      "unknown": "No name or number",
      "barAlt": "{{value}}",
      "summaryRides": "These {{shown}} took {{share}} of the period's rides.",
      "summarySpend": "These {{shown}} paid {{share}} of everything taken.",
      "summaryCostly": "These {{shown}} account for {{share}} of the {{total}} journeys lost.",
      "summaryFailed": "These {{shown}} account for {{share}} of the {{total}} orders nobody could fill.",
      "loyaltyViews": "Loyalty views",
      "viewPie": "Chart",
      "viewTable": "Table",
      "share": "Share",
      "slice": "{{band}}: {{count}} clients, {{share}}",
      "pieAlt": "How many clients rode how often in the period, as a ring",
      "journeys": "Their journeys",
      "journeysOf": "Journeys of {{name}}"
    },
    "directory": {
      "search": "Number, name or address",
      "origin": "Which clients",
      "everybody": "Everybody",
      "imported": "Imported",
      "here": "Met here",
      "order": "Order",
      "recent": "Most recent",
      "mostUsed": "Most used",
      "clients": "Clients",
      "none": "No client matches.",
      "client": "Client",
      "addresses": "Addresses",
      "uses": "Uses",
      "lastUsed": "Last used",
      "importedOne": "Imported",
      "app": "App",
      "blocked": "Blocked",
      "choose": "Choose a client to see who they are and where they go.",
      "name": "Name",
      "otherNumbers": "Other numbers",
      "notes": "Notes for the desk",
      "knownSince": "Known since",
      "importedOn": "imported {{date}}",
      "rides": "Orders here",
      "noOrders": "No orders here yet",
      "orderCounts": "{{total}} — {{completed}} completed, {{cancelled}} cancelled",
      "lastRide": "Last ride",
      "yes": "Signed in to the app",
      "no": "Not signed in",
      "knownAddresses": "Known addresses",
      "noAddresses": "No address is known for this client yet.",
      "address": "Address",
      "locked": "Locked",
      "noPoint": "No point",
      "recentOrders": "Recent orders",
      "when": "When",
      "route": "From / to",
      "state": "State",
      "fare": "Fare",
      "typedAs": "Saved as {{address}}"
    },
    "title": "Reports",
    "about": {
      "shiftBook": "What each driver worked, what it cost, and what is still owed.",
      "demand": "When the work comes in, where it comes from, and what nobody could fill.",
      "service": "How long a caller waits, who answers the offers, and what riders thought.",
      "clients": "Who rides most, who pays most, who costs journeys, and who has gone quiet.",
      "directory": "Every client your firm knows — the ones your previous system handed over too — with the addresses each is known to go to. Look anybody up by number, name or address.",
      "calls": "Every call, found by number or order, and its recording to hear, save or delete.",
      "journeys": "Every order that ended in the period, with what went wrong on it — and any one of them replayed on the map, minute by minute.",
      "addresses": "The addresses booked most in the period, pickups and the destinations passengers choose in the app, that are not yet the firm's own. Lock them, and the next car goes to the right door. Lock Google's first: each pin named by Google is a paid lookup."
    },
    "calls": {
      "search": "Number or order",
      "withheld": "Withheld number",
      "order": "Order {{reference}}",
      "dismiss": "Dismiss",
      "direction": {
        "label": "Direction",
        "all": "Both ways",
        "Inbound": "Incoming",
        "Outbound": "Outgoing"
      },
      "outcome": {
        "label": "Outcome",
        "all": "All",
        "answered": "Answered",
        "unanswered": "Missed",
        "other": "Refused or failed"
      },
      "outcomes": {
        "InProgress": "In progress",
        "Answered": "Answered",
        "Abandoned": "Hung up",
        "Missed": "Missed",
        "Failed": "Failed",
        "Refused": "Refused"
      },
      "dispatcher": "Dispatcher",
      "everyDispatcher": "Every dispatcher",
      "recordedOnly": "With a recording",
      "clear": "Clear filters",
      "none": "No calls in this period.",
      "noneMatch": "No call in this period matches.",
      "toCallBack": "Still to call back",
      "listenTo": "Play the call with {{who}}",
      "notHeard": "Not heard yet",
      "heard_one": "Heard once",
      "heard_other": "Heard {{count}} times",
      "showing": "{{from}}–{{to}} of {{total}}",
      "newer": "Newer",
      "older": "Older",
      "footnote": "Every call in the period, newest first. Each recording is kept until its date and then deleted; playing, saving and deleting one are each recorded with who did it, and that record stays after the recording has gone.",
      "tiles": {
        "calls": "Calls",
        "split": "{{inbound}} in · {{outbound}} out",
        "answered": "Answered",
        "answeredOf": "{{answered}} of {{inbound}} incoming",
        "unanswered": "Missed",
        "toCallBack_one": "{{count}} still to call back",
        "toCallBack_other": "{{count}} still to call back",
        "allCalledBack": "Every one dealt with",
        "ring": "Ringing before answer",
        "ringSub": "Average, incoming calls",
        "recorded": "Recorded",
        "recordedSub": "{{time}} of conversation",
        "recordedHours": "{{hours}} h of conversation"
      },
      "columns": {
        "when": "When",
        "who": "Caller",
        "dispatcher": "Dispatcher",
        "outcome": "Outcome",
        "ring": "Ringing",
        "talk": "Talking",
        "order": "Order",
        "recording": "Recording"
      },
      "trail": {
        "Played": "Played",
        "Downloaded": "Saved",
        "Deleted": "Deleted",
        "Expired": "Expired",
        "retention": "Retention period"
      },
      "player": {
        "label": "Recording player",
        "play": "Play",
        "pause": "Pause",
        "previous": "Previous recording",
        "next": "Next recording",
        "back10": "Back 10 seconds",
        "forward10": "Forward 10 seconds",
        "position": "Position in the recording",
        "speed": "Playback speed",
        "download": "Save",
        "delete": "Delete",
        "deleteCustomer": "Delete all of this caller's",
        "close": "Close the player",
        "takenBy": "with {{name}}",
        "gone": "Recording deleted",
        "deletesIn_one": "Deleted tomorrow",
        "deletesIn_other": "Deleted in {{count}} days",
        "neverPlayed": "Nobody has listened",
        "playedBy_one": "Heard once — by {{name}}, {{at}}",
        "playedBy_other": "Heard {{count}} times — last by {{name}}, {{at}}",
        "someone": "Somebody no longer at the firm",
        "keys": "Space plays · ← → 10 s · Shift ← → recording",
        "noTrail": "Nobody has played, saved or deleted it.",
        "couldNotPlay": "The recording would not play. Try again in a moment.",
        "couldNotSave": "The recording could not be saved.",
        "couldNotDelete": "The recording could not be deleted.",
        "deletedOne": "The recording was deleted. The call stays in the log.",
        "deletedCustomer_one": "{{count}} recording of this caller was deleted.",
        "deletedCustomer_other": "{{count}} recordings of this caller were deleted.",
        "deleteTitle": "Delete this recording?",
        "deleteBody": "The recording of the call with {{who}} at {{at}} is deleted for good. The call itself stays in the log, and the deletion is recorded with your name.",
        "deleteCustomerTitle": "Delete every recording of this caller?",
        "deleteCustomerConfirm": "Delete them all",
        "deleteCustomerBody": "Every recording of {{who}} the firm holds is deleted for good — what somebody asks for when they exercise their right to be forgotten. Their calls stay in the log.",
        "keep": "Keep it"
      },
      "replayOrder": "Replay the journey this call became"
    },
    "journeys": {
      "search": "Reference, number, name, address or plate",
      "state": {
        "label": "How it ended",
        "all": "All"
      },
      "sourceLabel": "Taken by",
      "source": {
        "all": "All",
        "phone": "Phone",
        "app": "App",
        "street": "Street"
      },
      "driver": "Driver",
      "everyDriver": "Every driver",
      "vehicle": "Car",
      "everyVehicle": "Every car",
      "oneClient": "One client only",
      "oneClientClear": "Show every client again",
      "clear": "Clear",
      "onlyProblems": "Only rides with:",
      "whatCounts": "What counts as a problem",
      "problems": {
        "late": "Late arrival",
        "detour": "Long way round",
        "longWait": "Long wait",
        "longStop": "Stop on the way",
        "speeding": "Speeding",
        "cancelledOnTheWay": "Called off on the way",
        "signalLost": "Signal lost",
        "noTrack": "No track"
      },
      "tiles": {
        "orders": "Orders",
        "ordersSub": "that ended in the period",
        "late": "more than {{minutes}} min after expected",
        "detour": "{{percent}}% or more over the best route",
        "longWait": "{{minutes}} min or more at the pickup",
        "speeding": "above {{town}} km/h in town, {{road}} outside"
      },
      "columns": {
        "when": "Asked for",
        "order": "Order",
        "client": "Client",
        "driver": "Driver",
        "state": "Ended",
        "arrival": "Arrival",
        "wait": "Waited",
        "distance": "Distance",
        "fare": "Fare",
        "problems": "Problems"
      },
      "replay": "Replay",
      "replayHelp": "Watch it on the map",
      "anonymous": "No name",
      "bookedFor": "booked for {{time}}",
      "versusBest": "{{percent}}% vs best",
      "none": "No order ended in this period.",
      "noneMatch": "No order matches these filters.",
      "showing": "{{from}}–{{to}} of {{total}}",
      "newer": "Newer",
      "older": "Older",
      "footnote": "Orders are counted by the day they were asked for. The expected arrival is the router's time from where the driver took the order, or the time a pre-booking was booked for. Journeys are kept from the day this report arrived; an older ride shows the route its fare was measured on, without times.",
      "noDriver": "No driver took it",
      "someDriver": "a driver",
      "automatic": "automatic",
      "chapter": {
        "before": "Before anything happened",
        "call": "The call",
        "searching": "Looking for a car",
        "approach": "To the client",
        "waiting": "Waiting",
        "aboard": "Client on board"
      },
      "phase": {
        "approach": "To the client",
        "waiting": "Waiting at the pickup",
        "aboard": "Client on board"
      },
      "span": {
        "stop": "Stood still for {{time}}",
        "silence": "No signal for {{time}}",
        "speeding": "Speeding, up to {{speed}} km/h where the limit is {{limit}}"
      },
      "events": {
        "title": "What happened",
        "created": "Order taken · {{who}}",
        "streetRide": "{{driver}} took it in the street",
        "offered": "Offered to {{driver}}",
        "accepted": "{{driver}} took it",
        "declined": "{{driver}} declined",
        "timedOut": "{{driver}} did not answer",
        "reassigned": "Taken away from {{driver}}",
        "superseded": "{{driver}} was too late — somebody else took it",
        "withdrawn": "Offer to {{driver}} withdrawn",
        "takenByHand": "Taken over by hand · {{who}}",
        "automaticResumed": "Handed back to automatic dispatch",
        "needsHuman": "Automatic dispatch asked for a dispatcher",
        "atRisk": "Pre-booking at risk: nobody yet",
        "noted": "Noted",
        "setOff": "The driver set off",
        "arrived": "The driver is at the pickup",
        "pickedUp": "The client got in",
        "completed": "Ride finished",
        "noShow": "The client did not come",
        "cancelled": "Called off · {{who}}",
        "rated": "Rated {{stars}} ★",
        "stopReached": "Reached the stop · {{address}}",
        "destinationReached": "Reached the destination · {{address}}",
        "callIn": "Call in",
        "callOut": "Call out"
      },
      "measures": {
        "title": "Expected and actual",
        "none": "Nothing to compare: no car was sent.",
        "accepted": "The driver took it",
        "expected": "Expected at the pickup",
        "basis": {
          "booked": "the time it was booked for",
          "routed": "the router's time from where the driver took it"
        },
        "arrived": "Arrived",
        "neverArrived": "Never arrived",
        "late": "{{time}} late",
        "early": "{{time}} early",
        "stood": "Stood",
        "fromPin": "{{distance}} from the pin",
        "waited": "Waited",
        "approach": "To the client",
        "ride": "The ride",
        "recommended": "best route {{distance}}",
        "rideTime": "Ride time",
        "routerSays": "the router says {{time}}",
        "ended": "Ended",
        "fromDestination": "{{distance}} from the destination asked for",
        "fare": "Fare",
        "fareLines": "Made up of"
      },
      "fare": {
        "title": "The fare",
        "none": "No fare: the ride did not happen, and nothing was charged for it.",
        "source": {
          "metered": "by the taximeter",
          "computed": "by the tariff",
          "fee": "a fee, for a ride that did not happen"
        },
        "quoted": "Quoted",
        "asQuoted": "exactly as quoted",
        "overQuote": "{{amount}} over the quote",
        "underQuote": "{{amount}} under the quote",
        "computed": "By the tariff",
        "meterAgrees": "the taximeter agrees",
        "meterOver": "the taximeter says {{amount}} more",
        "meterUnder": "the taximeter says {{amount}} less",
        "perKm": "Per kilometre",
        "perKmValue": "{{amount}}/km",
        "perKmSub": "over {{distance}} with the client aboard",
        "detour": "The long way round",
        "detourCost": "≈ {{amount}}",
        "detourSub": "{{distance}} over the best route",
        "detourNone": "none",
        "detourNoneSub": "the best route, or near enough",
        "lines": "Made up of",
        "total": "Total"
      },
      "calls": {
        "title": "Calls",
        "jump": "Go to this call on the timeline",
        "announced_one": "Told {{count}} min",
        "announced_other": "Told {{count}} min",
        "hear": "Hear it · {{time}}",
        "notRecorded": "Not recorded"
      },
      "player": {
        "back": "All journeys",
        "timeline": "Timeline",
        "folded": "{{time}} folded away — nothing happened",
        "callTick": "Call at {{time}}",
        "gpx": "GPX",
        "gpxHelp": "The track as a file any map program opens",
        "print": "Print",
        "recordedBefore": "This order ended before journeys were kept. The line is the route its fare was measured on, without times, so it cannot be played.",
        "noTrack": "A car set off, but its phone sent nothing for this order.",
        "neverTaken": "Nobody took this order, so there is no journey — only what happened while a car was looked for.",
        "speed": "{{speed}} km/h",
        "noSignal": "No signal",
        "hearing": "The call is playing",
        "callMuted": "Call — silent above 2×",
        "previous": "Previous chapter",
        "back10": "Back 10 seconds",
        "play": "Play",
        "pause": "Pause",
        "forward10": "Forward 10 seconds",
        "next": "Next chapter",
        "speedLabel": "Speed",
        "follow": "Follow",
        "followHelp": "Keep the car in the middle of the map while it plays",
        "keys": "Space plays · ← → 10 s · Shift ← → chapter · − + speed · F follow",
        "beingWritten": "This ride ended a moment ago, and its journey is still being written down. In a minute it can be replayed.",
        "askAgain": "Try again"
      },
      "map": {
        "label": "Map of the journey",
        "pickup": "Pickup: {{address}}",
        "stop": "Stop: {{address}}",
        "destination": "Destination: {{address}}",
        "recommended": "Best route",
        "fareRoute": "Route of the fare",
        "silence": "No signal",
        "unplannedStop": "Stop on the way",
        "droppedOff": "Where the ride ended — no destination was asked for"
      },
      "sheet": {
        "title": "Ride sheet — order {{reference}}",
        "order": "Order",
        "state": "Ended as",
        "requested": "Asked for",
        "client": "Client",
        "from": "From",
        "to": "To",
        "driver": "Driver and car",
        "recommended": "Best route",
        "problems": "Flagged:",
        "printed": "Printed {{when}}"
      },
      "metres": "{{count}} m",
      "speed": {
        "title": "Speed",
        "limit": "limit {{speed}} km/h",
        "limitTown": "limit {{speed}} km/h in town",
        "limitRoad": "limit {{speed}} km/h out of town",
        "limits": "limit {{town}} in town · {{road}} outside, km/h",
        "none": "No speed was recorded for this ride.",
        "top": "Top speed",
        "at": "at {{time}}",
        "average": "Average while moving",
        "averageSub": "stops and lights left out",
        "over": "Above the limit",
        "never": "never",
        "still": "Standing still",
        "stillSub": "the wait at the pickup included",
        "unit": "km/h",
        "chart": "Speed over the ride, with the {{speed}} km/h limit"
      },
      "order": {
        "title": "The order",
        "problems": "What went wrong",
        "clean": "Nothing — the ride kept to the firm's rules.",
        "show": "Show",
        "showHelp": "Play the replay from this moment",
        "explain": {
          "late": "Arrived {{time}} after the expected time.",
          "detour": "{{driven}} driven, against {{best}} by the best route — {{percent}}% longer.",
          "longWait": "Waited {{time}} at the pickup.",
          "longStop": "Stood still for {{time}} at {{at}}, away from anywhere the order asked for.",
          "speeding": "Up to {{speed}} km/h where the limit is {{limit}}, at {{at}}.",
          "signalLost": "No signal for {{time}} from {{at}}.",
          "cancelledOnTheWay": "Called off at {{at}} while the car was on its way.",
          "cancelledAway": "Called off at {{at}}, with the car {{distance}} from the pickup.",
          "noTrack": "A car set off, but its phone sent nothing for this order."
        },
        "time": "Where the time went",
        "total": "In all",
        "asked": "What was asked for",
        "taken": "Taken",
        "forWhen": "For",
        "now": "now",
        "from": "From",
        "notes": "For the driver",
        "via": "Through",
        "to": "To",
        "noDestination": "not given",
        "passengers": "Passengers",
        "car": "Car",
        "anyCar": "any"
      }
    },
    "addresses": {
      "address": "Address",
      "bookings": "Bookings",
      "namedEntrance": "Named an entrance",
      "last": "Last booked",
      "place": "Place it",
      "empty": "Every address booked in this period is already one of the firm's addresses.",
      "namedBy": "Named by",
      "all": "All",
      "google": "Google",
      "ours": "Our maps",
      "imported": "Imported",
      "importedAbout": "Addresses your previous system had placed on its map, most ordered there first. They were never booked here, so no period applies. Lock one and the next comes up.",
      "importedEmpty": "No imported address with a point is left to lock.",
      "ordersBefore": "Orders before",
      "importedOne": "Imported",
      "order": "Order",
      "byBookings": "Most booked",
      "byLatest": "Most recent",
      "byAddress": "A–Z",
      "byCallers": "Most callers",
      "lastUsed": "Last used",
      "search": "Search addresses",
      "callers": "Callers",
      "spellings": "Also written: {{list}}",
      "noneFound": "No address on this list matches the search.",
      "join": "Join…",
      "joinTitle": "Join “{{line}}” to a locked address",
      "joinAbout": "Orders and addresses keep the text they were typed with; they will show as the chosen address. It can be undone from the address's history.",
      "joinSearch": "Search locked addresses",
      "joinCandidates": "Which locked address",
      "joinNoCandidates": "No similar locked address — search for it by name or address.",
      "joinMembers": "What is joined",
      "inPeriod": "In this period",
      "outsidePeriod": "Outside the period",
      "callersAddresses": "Callers' addresses",
      "outsideMore": "The newest {{shown}} of {{total}} are shown.",
      "reason": {
        "joinedBefore": "Joined before",
        "same": "Same address",
        "building": "Another entrance",
        "words": "Similar words",
        "name": "Name",
        "near": "Nearby",
        "search": "Search",
        "sameName": "Same name"
      },
      "metres": "{{n}} m",
      "sharesPoint": "shares its point with {{n}} more",
      "live": "still in progress",
      "far": "{{n}} m away",
      "linked": "already locked",
      "joinChosen": "Chosen: {{count}} of {{total}}",
      "joinTarget": "to “{{line}}”",
      "joinConfirm": "Join",
      "joined": "Joined to “{{line}}”: {{orders}}, {{destinations}}, {{addresses}}",
      "joinSkipped": "Left alone — {{list}}",
      "skipped": {
        "live": "in progress: {{shown}}",
        "linked": "already locked: {{shown}}",
        "far": "far away: {{shown}}",
        "gone": "no longer there: {{shown}}"
      },
      "undo": "Undo",
      "undone": "The join was undone.",
      "dismiss": "Remove from the list",
      "dismissTitle": "Remove “{{line}}” from the list?",
      "dismissBody_one": "{{shown}} booking stays in history unchanged. A new booking at it brings it back.",
      "dismissBody_other": "{{shown}} bookings stay in history unchanged. A new booking at it brings it back.",
      "dismissConfirm": "Remove",
      "dismissed": "Removed: “{{line}}”.",
      "restore": "Restore",
      "restored": "Back on the list: “{{line}}”.",
      "remove": "Delete…",
      "removeTitle": "Delete the imported addresses of “{{line}}”?",
      "removeBody": "Leaving the screen-pop and the directory: {{addresses}} of {{callers}}. Orders stay. This cannot be undone; importing the same file again will not bring them back.",
      "removeUnderstand": "I understand",
      "removeConfirm": "Delete",
      "removeNone": "Nothing to delete: every one of these addresses has been used from here.",
      "usedHere": "used from here — stays",
      "removed": "Deleted: {{addresses}} of {{callers}}.",
      "removedKept": "Kept: {{kept}} — used from here or already locked.",
      "points": "Point",
      "withPoint": "With a point",
      "noPoint": "No point",
      "noPointAbout": "Addresses your previous system handed over with no point. There is nowhere to open the map, so each is joined to a locked address or deleted.",
      "noPointEmpty": "No imported address without a point is left.",
      "hint": "≈ {{line}} · {{metres}}",
      "hintNear": "≈ {{line}}",
      "hintTitle": "Join to “{{line}}” — {{reason}}",
      "tiles": {
        "waiting": "Waiting",
        "waitingSub": "booked in the period",
        "google": "Named by Google",
        "googleSub_one": "{{shown}} booking paid a lookup",
        "googleSub_other": "{{shown}} bookings paid a lookup",
        "imported": "Imported",
        "importedSub": "at the previous system's point",
        "noPoint": "No point",
        "noPointSub": "join or delete only"
      }
    }
  },
  "branding": {
    "title": "Branding",
    "intro": "Your colour, your logo and where your customers read the terms. This is what your passengers and drivers see.",
    "primaryColor": "Accent colour",
    "primaryColorHint": "Buttons and highlights, here and in both apps. The console changes at once; a phone picks the new colour up when its app is next opened and wears it from the start after that. Danger, warning and confirmation colours are fixed — they carry meaning rather than identity.",
    "termsUrl": "Terms",
    "privacyUrl": "Privacy notice",
    "urlHint": "Must start with https.",
    "logo": "Logo",
    "logoHint": "PNG, JPEG or WebP, up to 512 KB. Shown on the sign-in screen and in the header.",
    "chooseLogo": "Choose a file",
    "uploadLogo": "Upload",
    "uploading": "Uploading…",
    "removeLogo": "Remove",
    "noLogo": "No logo yet.",
    "saved": "Saved",
    "couldNotLoad": "Could not read the branding.",
    "couldNotSave": "Could not save the branding.",
    "couldNotUpload": "Could not upload the logo.",
    "firmTitle": "Your company",
    "firmIntro": "The name your passengers and drivers see. The company code beside it is permanent; this is not.",
    "displayName": "Company name",
    "displayNameHint": "What appears in the apps and on the sign-in screen. A branded build keeps the name it was released with.",
    "linesTitle": "Phone lines",
    "linesIntro": "The numbers customers ring, in the order you want them read. Passengers see the ones you show them; the one you flag is what both apps dial when something goes wrong.",
    "lineLabel": "Label",
    "lineNumber": "Number",
    "lineKind": "Kind",
    "lineShown": "Shown to passengers",
    "lineSupport": "The apps dial this one",
    "addLine": "Add a line",
    "removeLine": "Remove",
    "noLines": "No lines yet. Add the one customers ring.",
    "lineKinds": {
      "Booking": "Booking line",
      "Mobile": "Mobile",
      "Office": "Office",
      "WhatsApp": "WhatsApp",
      "Viber": "Viber"
    },
    "aboutTitle": "About the company",
    "aboutIntro": "A few sentences for passengers, and where and when you can be found.",
    "aboutUs": "About us",
    "aboutUsHint": "Up to six hundred characters, shown in the passenger app.",
    "website": "Website",
    "email": "Contact email",
    "emailHint": "A public address, as distinct from your own sign-in.",
    "openingHours": "Opening hours",
    "openingHoursHint": "As a line of text: 24/7, or a sentence.",
    "officeAddress": "Office address",
    "officeAddressHint": "Shown to passengers, never navigated to.",
    "couldNotLoadProfile": "Could not read the company's profile.",
    "couldNotSaveProfile": "Could not save the company's profile."
  },
  "appearance": {
    "title": "What the drivers’ phones look like",
    "intro": "The office decides this, not the driver — a phone in a cab is a work tool, and the app carries no control of its own. Dark by default, because a white screen on a windscreen mount at night is a reflection in the glass. One driver who needs something different gets it on the Fleet tab, and his own setting beats this one.",
    "driverApp": "Driver app",
    "driverAppHelp": "System follows whatever each driver has set his handset to, and changes with it at sunset. Light and dark ignore the handset entirely. A driver already holding an open app is told immediately; everybody else sees it the next time the app starts.",
    "applyToAll": "Apply to every driver now",
    "applyHelp": "Saving the setting above changes what drivers follow. This clears every individual driver’s own setting as well, so that nobody is left on an exception somebody made months ago.",
    "applyWarning": "This clears the appearance setting on every driver who has one of their own, and cannot be undone. The setting above changes on its own without this.",
    "applied_one": "Done. One driver’s own setting was cleared.",
    "applied_other": "Done. {{count}} drivers’ own settings were cleared.",
    "appliedToNobody": "Done. No driver had a setting of their own, so nothing changed.",
    "apply": "Apply now",
    "applyNeedsSave": "Save the setting above first — otherwise this would leave every driver following the old one."
  },
  "import": {
    "title": "Customers from your previous system",
    "intro": "Your callers and the addresses they use, carried over. Nothing is written until you have seen what would happen.",
    "format": "Format",
    "formats": {
      "csv": "CSV",
      "xlsx": "Excel",
      "json": "JSON",
      "telcom": "Telcom phone book"
    },
    "formatHint": {
      "csv": "A comma or semicolon file. Columns are found by their headings, in either language.",
      "xlsx": "A spreadsheet, saved as it is. Format the phone column as text before saving, or Excel drops the leading zero.",
      "json": "An array of people, each with their addresses.",
      "telcom": "Telcom’s own TelBook file, exactly as it is on the old machine."
    },
    "file": "File",
    "areaCode": "Area code",
    "areaCodeHint": "For local numbers stored without one. Without it, those rows are refused rather than guessed at.",
    "preview": "See what would happen",
    "commit": "Import for real",
    "working": "Reading…",
    "wouldDo": "What would happen",
    "done": "What was done",
    "rejects": "Rows that could not be read",
    "truncated": "Only the first rows are listed. The counts above are complete.",
    "row": "Row",
    "reason": "Reason",
    "value": "Value",
    "couldNotRun": "The file could not be read.",
    "count": {
      "read": "Rows read",
      "customersCreated": "New customers",
      "customersMatched": "Already known",
      "addressesAdded": "Addresses added",
      "addressesAlreadyKnown": "Addresses already there",
      "skipped": "Skipped",
      "rejected": "Refused",
      "addressesRemovedEarlier": "Deleted earlier"
    },
    "chooseFile": "Choose a file"
  },
  "invite": {
    "title": "Choose your password",
    "intro": "You have been given an account at {{firm}}, for {{email}}. Choose a password and you are in.",
    "password": "Password",
    "passwordHint": "At least twelve characters. Length beats punctuation — a phrase you will remember is a better password than a short one with symbols in it.",
    "again": "Type it again",
    "submit": "Set my password and sign in",
    "working": "Setting…",
    "mismatch": "Those two passwords are not the same.",
    "couldNotAccept": "Could not use that link.",
    "askForAnother": "Ask whoever invited you to send another link."
  },
  "notStaff": {
    "title": "This website is for the office",
    "body": "Your account here is a driver's. Drivers work in the firm's driver app on their phone: open it and sign in with the same email and password.",
    "signOut": "Sign out"
  },
  "fleet": {
    "couldNotLoad": "Could not read the fleet.",
    "couldNotSave": "Could not save that.",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "remove": "Remove",
    "owner": {
      "Driver": "Driver",
      "Vehicle": "Vehicle"
    },
    "expiring": {
      "title": "Expiring soon",
      "help": "Paperwork that is about to stop somebody working. A driver whose licence has lapsed is refused at sign-on, so this list is how you find out first rather than at six in the morning.",
      "none": "Nothing expires in the next month.",
      "expired_one": "Expired {{date}} — {{count}} day ago",
      "expired_other": "Expired {{date}} — {{count}} days ago",
      "inDays_one": "Expires {{date}} — {{count}} day left",
      "inDays_other": "Expires {{date}} — {{count}} days left"
    },
    "drivers": {
      "title": "Drivers",
      "help": "Everyone on the books. Somebody who has left is still listed, because their completed rides are still theirs and this is the only screen that can bring them back.",
      "none": "Nobody on the books yet.",
      "hire": "Hire a driver",
      "hiring": "Hiring a driver",
      "editing": "Editing a driver",
      "email": "Their email address",
      "emailHelp": "They are sent a link and choose their own password. If they already have an account here or at another company on this system, that account is used and nothing is sent.",
      "name": "Their name",
      "nameHelp": "What dispatchers and passengers see.",
      "phone": "Their number",
      "phoneHelp": "Dispatchers ring drivers constantly.",
      "callSign": "Short number",
      "callSignHelp": "The short number a car goes by over the radio, if this company uses them.",
      "notes": "Notes",
      "notesHelp": "For dispatchers: prefers airport runs, no cash.",
      "noNumber": "no number",
      "noVehicle": "no car",
      "offboard": "They have left",
      "reinstate": "Hire back",
      "invited": "An invitation has been sent to {{email}}.",
      "existingAccount": "{{email}} already had an account, so nothing was sent — they sign in with the password they have.",
      "offboarded": "{{name}} has been taken off the books. Their sessions have ended and their role is suspended.",
      "offboardedKeepsRole": "{{name}} has been taken off the books and their sessions have ended. They hold another role here, so their console access was left alone.",
      "reinstated": "{{name}} is back on the books.",
      "settings": "Settings",
      "appTheme": "App appearance",
      "appThemeHelp": "What this driver’s app looks like. Following the firm means {{firm}} today, and follows it if the firm changes its mind. Anything else applies to him alone.",
      "followsFirm": "Follow the firm",
      "hasAppThemeOverride": "own appearance"
    },
    "vehicles": {
      "title": "Vehicles",
      "help": "Every car. A retired one is still listed so it can be put back on the road.",
      "none": "No cars registered yet.",
      "register": "Register a car",
      "registering": "Registering a car",
      "editing": "Editing a car",
      "plate": "Registration",
      "plateHelp": "Typed however you like — spaces and case are ignored, so CA 1234 AB and ca1234ab are the same car.",
      "makeModel": "Make and model",
      "make": "Make",
      "model": "Model",
      "colourYear": "Colour and year",
      "colourHelp": "Colour is what tells two identical cars apart in a yard.",
      "category": "Class",
      "categoryHelp": "What the car is: one class each. Decides which bookings it is offered.",
      "featuresHelp": "Everything this car can take or do. Choose any number; an order that asks for one goes only to cars that have it.",
      "seatsLabel": "Passenger seats",
      "seatsHelp": "Not counting the driver.",
      "seats_one": "{{count}} seat",
      "seats_other": "{{count}} seats",
      "notes": "Notes",
      "nobodyInIt": "nobody in it",
      "retire": "Take off the road",
      "restore": "Put back on the road",
      "colour": "Colour",
      "year": "Year",
      "features": "What it offers"
    },
    "documents": {
      "title": "Paperwork",
      "none": "Nothing on record.",
      "record": "Record it",
      "kind": "Document",
      "description": "What it is",
      "descriptionHelp": "Only for documents this system has no name for.",
      "number": "Number",
      "dates": "Issued and expires",
      "datesHelp": "Expiry is the one that matters — it is checked at every sign-on. Leave it blank for a document that does not expire.",
      "expiresOn": "Expires on",
      "valid": "valid to {{date}}",
      "expiringSoon": "expires {{date}}",
      "expired": "expired {{date}}",
      "noExpiry": "no expiry",
      "hasExpired": "expired paperwork",
      "blocking": "No current {{kind}} on record, so this cannot be signed on.",
      "issuedOn": "Issued on"
    },
    "documentKinds": {
      "DrivingLicence": "Driving licence",
      "TaxiDriverCertificate": "Taxi driver certificate",
      "MedicalCertificate": "Medical certificate",
      "VehicleRegistration": "Vehicle registration",
      "Insurance": "Insurance",
      "RoadworthinessCertificate": "Roadworthiness certificate",
      "TaxiPermit": "Taxi permit",
      "Other": "Something else"
    },
    "staff": {
      "title": "Office staff",
      "help": "Who takes the calls, and who configures the company. Invited by address, exactly as you were — they choose their own password from the link.",
      "none": "Nobody in the office yet.",
      "inviting": "Invite somebody",
      "invite": "Send the invitation",
      "email": "Their email address",
      "emailHelp": "If they already have an account here or at another company on this system, that account is used and nothing is sent.",
      "name": "Their name",
      "roles": "What they may do",
      "role": {
        "Dispatcher": "Take calls and send cars",
        "TenantAdmin": "Configure the company"
      },
      "suspend": "Withdraw access",
      "invited": "An invitation has been sent to {{email}}.",
      "existingAccount": "{{email}} already had an account, so nothing was sent — they sign in with the password they have.",
      "suspended": "Access withdrawn from {{name}}. Their telephone extension has gone with it."
    },
    "close": "Close",
    "columns": {
      "who": "Who",
      "expires": "Expires",
      "name": "Name",
      "phone": "Telephone",
      "car": "Car",
      "state": "State",
      "plate": "Registration",
      "seats": "Seats",
      "driver": "Driver",
      "roles": "Rights"
    },
    "telephone": {
      "open": "Telephone",
      "title": "{{name}}’s telephone",
      "answerOn": "Answers on",
      "answerOnHelp": "The telephone that rings first. They can change this themselves in the console.",
      "ringOther": "Ring the other telephone when this one cannot be reached",
      "alsoRingOther": "Also ring the other telephone if this one is not answered after",
      "whenOnACall": "When already on a call",
      "whenOnACallHelp": "Showing the second call lets them take it; taking it puts the first caller on hold on the telephone system, where anybody can take them back.",
      "showAndTake": "Show it and let them take it",
      "sendToOthers": "Busy: send it to someone else",
      "lines": "Lines",
      "linesHelp": "Which of the firm’s numbers ring for them. A call nobody given its line can take still rings everybody who can.",
      "allLines": "All of the firm’s lines",
      "noLines": "The firm has no numbers set in the telephony settings."
    },
    "allowed": {
      "sectionTitle": "Who drives what",
      "sectionHelp": "Whether a driver signs into any free car, or only the cars you allow him. Allowing cars keeps a driver out of one he is not insured or licensed for.",
      "anyCar": "Drivers may take any free car",
      "anyCarOn": "Every driver sees every free car in his app. The cars you allowed each driver are kept for when you switch this off.",
      "anyCarOff": "A driver sees only the cars you allowed him, and is refused any other. Choose them under Car, on each driver.",
      "title": "Cars {{name}} may drive",
      "help": "Choose every car this driver may sign into. One car can be shared by several drivers — the day and the night shift.",
      "cars": "Cars",
      "none": "No cars allowed yet",
      "choose": "Choose cars",
      "count_one": "{{count}} car",
      "count_other": "{{count}} cars",
      "find": "Find a car by plate, make or model"
    }
  },
  "mfa": {
    "title": "Enter your code",
    "code": "Code",
    "codeHint": "Six digits from your authenticator app, or one of your recovery codes.",
    "submit": "Continue",
    "checking": "Checking…",
    "startAgain": "Start again",
    "couldNotStart": "Could not start setting up an authenticator.",
    "couldNotVerify": "That code could not be checked.",
    "enrol": {
      "title": "Set up your authenticator",
      "why": "This account can see every customer this company has, so it needs a second factor as well as a password. Scan this with an authenticator app — Google Authenticator, Aegis, 1Password, whichever you use — and type the code it shows.",
      "qrAlt": "A QR code carrying this account’s authenticator secret",
      "orType": "Cannot scan? Type this into the app instead:",
      "codeHint": "The six digits your authenticator app is showing now."
    },
    "recovery": {
      "title": "Your recovery codes",
      "once": "These are shown once and are not stored anywhere we can read them. Write them down or put them in a password manager before you continue.",
      "what": "Each one works in place of a code, once. They are how you get in if you lose your phone — otherwise somebody has to reset you.",
      "saved": "I have saved them",
      "copy": "Copy",
      "copied": "Copied"
    },
    "reset": "Reset their authenticator",
    "resetConfirm": "Reset the authenticator for {{name}}? They will set a new one up at their next sign-in, and every session they have open will end.",
    "resetDone": "Done. {{name}} sets up a new authenticator at their next sign-in."
  },
  "person": {
    "menu": "Your account",
    "you": "You",
    "entrances": "Entrances",
    "entrancesFirm": "As the firm chose ({{way}})",
    "entrancesWay": {
      "list": "In the list",
      "after": "After the address"
    },
    "numbers": "Street numbers",
    "numbersWay": {
      "list": "In the list",
      "after": "After the street"
    }
  },
  "nav": {
    "views": "View",
    "view": {
      "desk": "Desk",
      "map": "Map",
      "timeline": "Timeline"
    },
    "pin": "Open this view at sign-in",
    "pinned": "Opens at sign-in",
    "backToDispatch": "Back to dispatch",
    "area": {
      "dispatch": "Dispatch",
      "settings": "Company settings",
      "reports": "Reports",
      "whatsNew": "What's new"
    },
    "settingsGroup": {
      "dispatch": "Dispatch",
      "money": "Money",
      "people": "People",
      "firm": "Firm",
      "simulation": "Simulation",
      "gettingStarted": "Getting started"
    },
    "settings": {
      "setup": "Setup",
      "dispatch": "Dispatch",
      "zones": "Zones and ranks",
      "map": "Map",
      "prices": "Prices",
      "surcharges": "Night and holidays",
      "duty": "Duty and rates",
      "fleet": "Fleet",
      "branding": "Branding",
      "telephony": "Telephones",
      "import": "Import customers",
      "simulation": "Simulation",
      "search": "Address search",
      "replay": "Ride replay",
      "driverApp": "Driver app",
      "places": "Addresses",
      "labels": "Order labels",
      "cancellations": "Cancellation reasons",
      "devices": "Devices"
    },
    "reports": {
      "shift-book": "Shift book",
      "demand": "When and where",
      "service": "Service",
      "clients": "Clients",
      "directory": "Client book",
      "calls": "Calls",
      "journeys": "Journeys",
      "addresses": "Addresses to place"
    },
    "settingsAbout": {
      "setup": "How ready the company is, and what is left to do.",
      "dispatch": "How an order finds a driver, and what happens when none is found.",
      "zones": "The city as this firm divides it, and the ranks inside it.",
      "map": "Where this firm's maps open: the desk, the passenger app when the phone cannot say where it is, and the zone editor until a zone exists.",
      "prices": "What a ride costs, what a cancellation costs, and what a ride records as paid.",
      "surcharges": "When the meter runs higher: nights, holidays, and the calendar behind them.",
      "duty": "What counts as a day worked, and what a driver owes the firm for it.",
      "fleet": "Who the firm runs on: drivers, cars, their paperwork and the office.",
      "branding": "The firm's name and colour, and what its drivers' phones look like.",
      "telephony": "The telephone system, and what a caller hears while they wait.",
      "import": "Carrying a firm's callers and their addresses over from its old system.",
      "simulation": "The simulated firms: bots that drive, orders that arrive, a desk that rings.",
      "search": "Where the desk looks for an address: the town, the villages around it, and further. The dispatcher switches between the three while taking the call.",
      "replay": "How long journeys are kept, and what the Journeys report calls a problem.",
      "driverApp": "What your drivers' phones can do: messages, the alarm, the heatmap, where the driver is going, the next job before the current ends, fares and the taximeter.",
      "places": "The firm's own addresses: the entrances and places the map does not have, placed once and locked, and found first by every search.",
      "labels": "What an order can ask of a car — luggage, a pet, paying by card — and the picture the passenger app shows for each.",
      "cancellations": "The reasons a passenger can give for cancelling in the app, and the order they are offered in.",
      "devices": "The company's phones and tablets and the drivers' own phones: who has each, which are free and which are written off."
    }
  },
  "timeline": {
    "title": "Next two hours",
    "now": "now {{time}}",
    "driver": "Driver",
    "onShift_one": "{{count}} on shift",
    "onShift_other": "{{count}} on shift",
    "waiting": "Waiting",
    "orders_one": "{{count}} order",
    "orders_other": "{{count}} orders",
    "booked": "Booked",
    "inWindow": "{{count}} in window",
    "beyond": "{{count}} beyond",
    "searchStarts": "search starts {{time}}",
    "freeSince": "free since {{time}}",
    "freeSinceAt": "free since {{time}} · at {{rank}}",
    "freeAt": "free {{time}}",
    "shiftEnds": "shift ends {{time}}",
    "offered": "offered {{reference}} · {{seconds}} s to answer",
    "break": "break",
    "onCall": "On a call",
    "newOrderForCaller": "New order for this caller",
    "nobody": "Nobody is on shift.",
    "unavailable": "The timeline could not be loaded.",
    "legend": {
      "ride": "on a ride",
      "toPickup": "going to pickup",
      "offered": "offered",
      "break": "break",
      "shiftEnds": "shift ends"
    },
    "strip": {
      "freeNow": "free now",
      "freeWithin15Min": "more free within 15 min",
      "waitingOver10Min": "waiting over 10 min",
      "bookedWithinHour": "bookings due within the hour",
      "shiftsEndingWithinHour": "shifts ending within the hour"
    }
  },
  "setup": {
    "sinceTheStart": "the start",
    "chip": "Setup · {{percent}}%",
    "progress": "{{settled}} of {{total}}",
    "percent": "{{percent}}%",
    "intro": "Everything here is judged from what the company actually has, never from a tick. Mark anything you do not need, and come back any time.",
    "complete": "Your company is set up.",
    "completeHint": "Every item is done or marked not needed. The list stays here as a map of the settings, and anything marked not needed can be brought back.",
    "couldNotLoad": "Could not read the setup.",
    "couldNotSave": "Could not save that.",
    "open": "Open",
    "notNeeded": "Not needed",
    "needed": "Needed after all",
    "startGuide": "Start the guided setup again",
    "resumeGuide": "Continue the guided setup",
    "state": {
      "Todo": "To do",
      "InProgress": "In progress",
      "Done": "Done",
      "NotNeeded": "Not needed"
    },
    "group": {
      "beforeFirstBooking": "Before the first booking",
      "face": "Your company's face",
      "city": "The city",
      "money": "Money",
      "customers": "Your customers",
      "withUs": "With us"
    },
    "groupHint": {
      "beforeFirstBooking": "The system refuses a booking without these.",
      "face": "What passengers and drivers see.",
      "city": "How an order finds a car.",
      "money": "What is charged, and what a driver owes.",
      "customers": "So the screen-pop knows callers on day one.",
      "withUs": "Set up together with whoever runs the platform. Shown here, not counted."
    },
    "item": {
      "tariff": {
        "title": "A tariff",
        "why": "No fare can be quoted or recorded without one.",
        "done": "{{name}}, since {{date}}"
      },
      "dispatcher": {
        "title": "Somebody to take calls",
        "why": "A dispatcher, invited by email. They choose their own password from the link.",
        "done": "{{name}}",
        "inProgress": "Invited: {{email}}"
      },
      "driver": {
        "title": "A driver who can sign on",
        "why": "Hired, with a current driving licence recorded. Without one they are refused at sign-on.",
        "done": "{{name}}"
      },
      "vehicle": {
        "title": "A car with papers",
        "why": "Registered, with current insurance recorded. A car with none cannot be signed into.",
        "done": "{{plate}}"
      },
      "logo": {
        "title": "A logo",
        "why": "Shown on the sign-in screen, in the header and in both apps.",
        "done": "Uploaded"
      },
      "lines": {
        "title": "Phone lines",
        "why": "The numbers passengers ring, and the one both apps dial.",
        "done": "{{count}} shown to passengers"
      },
      "about": {
        "title": "About the company",
        "why": "A few sentences passengers read in the app.",
        "done": "Written"
      },
      "legal": {
        "title": "Terms and privacy links",
        "why": "The passenger app shows both, and the stores expect them.",
        "done": "Both set"
      },
      "mapHome": {
        "title": "Where you are on the map",
        "why": "Every map opens here. Taken from your largest zone when you have one; otherwise pan a small map to your city and save.",
        "done": "{{source}}"
      },
      "zones": {
        "title": "Zones and ranks",
        "why": "Without any, orders are offered in widening circles, which works.",
        "done": "{{count}} zones",
        "notNeededAs": "We dispatch by distance"
      },
      "addressSearch": {
        "title": "Where address search looks",
        "why": "Draw your town and the desk searches there first, with a switch for the villages and further. Without it, every search covers the whole country.",
        "done": "{{count}} of 3 levels drawn",
        "notNeededAs": "We search everywhere"
      },
      "autoDispatch": {
        "title": "Automatic dispatch, decided",
        "why": "Off until you trust the console. Switch it on, or say you assign by hand.",
        "done": "Switched on",
        "notNeededAs": "We assign by hand"
      },
      "surcharges": {
        "title": "Night and holiday rates",
        "why": "Only bites at ten in the evening, and on the days you name.",
        "done": "{{rules}} rules, {{holidays}} holidays"
      },
      "duty": {
        "title": "What a day costs",
        "why": "Only bites when the first month is settled — but before that, not after.",
        "done": "{{amount}} {{currency}} a day"
      },
      "fees": {
        "title": "Cancellation and no-show fees, decided",
        "why": "Both start at zero, meaning you charge nothing. Say so, or set an amount.",
        "done": "Set",
        "notNeededAs": "We charge nothing"
      },
      "customers": {
        "title": "Callers from the old system",
        "why": "Imported from a file, so the desk knows callers on the first day rather than after a month.",
        "done": "{{count}} customers",
        "notNeededAs": "We start fresh"
      },
      "telephony": {
        "title": "The telephone system",
        "why": "Commissioned together with whoever runs the platform. This ticks itself when the console hears from the PBX.",
        "done": "Connected",
        "inProgress": "Configured, waiting to hear from the PBX"
      }
    },
    "guide": {
      "stepOf": "Step {{step}} of {{total}}",
      "back": "Back",
      "next": "Next",
      "skip": "Skip this step",
      "notNow": "Not now",
      "start": "Let's go",
      "finish": "Open the checklist",
      "toDesk": "Open the desk",
      "saving": "Saving…",
      "welcome": {
        "title": "Welcome, {{firm}}",
        "body": "Your system works already: the desk is open and calls can be taken. These screens take about five minutes and make it yours. Anything can be skipped and finished later, from Settings → Setup."
      },
      "firm": {
        "title": "Your company",
        "body": "The name, logo and colour your passengers and drivers see.",
        "preview": "How the console header will look"
      },
      "reach": {
        "title": "How customers reach you",
        "body": "The lines they ring, a few words about you, and where you are."
      },
      "people": {
        "title": "Your people",
        "body": "Invite a dispatcher by email. They choose their own password from the link. A company run by one person can skip this.",
        "email": "Their email",
        "name": "Their name",
        "dispatcher": "Dispatcher",
        "admin": "Administrator",
        "invite": "Send the invitation",
        "sent": "Invitations sent",
        "invited": "Sent to {{email}}",
        "existing": "{{email}} already had an account, so nothing was sent; they sign in with the password they have."
      },
      "done": {
        "title": "The basics are done",
        "body": "Here is what still stands between you and the first booking, and what pays off later. Everything on the list can be finished in any order, from Settings → Setup."
      }
    }
  },
  "desks": {
    "which": "Which desk are you at?",
    "whichHelp": "Its phones will ring for you. This computer remembers the answer; change it from the telephone menu.",
    "takenBy": "{{name}} is at it",
    "none": "No desk",
    "desk": "Desk",
    "yours": "Your desk: {{desk}} · {{extension}}",
    "couldNotChoose": "The desk could not be chosen."
  },
  "parked": {
    "title": "On hold",
    "heldBy": "held by {{name}} · {{time}}",
    "somebody": "somebody",
    "take": "Take",
    "couldNotTake": "The caller could not be taken back.",
    "order": "Order {{reference}}"
  },
  "phoneLines": {
    "title": "Lines",
    "help": "The SIMs in the gateway and the trunk, as the telephone system knows them. Adding one here is what creates it on the PBX, under the name and password typed here — the same two the gateway’s own page is given. A gateway set to one account for the whole box is one line; a gateway whose SIMs each register as their own account is one line per SIM, and only then can a call be sent out of a particular SIM. A provider’s trunk set up in the telephone system’s own configuration — a landline arriving on a line of its own, say — is added with its name and no password: it is listed here as it is, and nothing is written to the PBX.",
    "add": "Add a line",
    "none": "No lines yet. Calls still arrive on whatever the PBX was set up with by hand; list them here to name them and to choose which one a call goes out on.",
    "label": "Called",
    "labelHelp": "What the office calls it, like SIM 3 — A1.",
    "name": "Name on the PBX",
    "nameHelp": "Lowercase letters, digits, hyphens and underscores, starting with a letter: gsm-goip, or gsm-goip-3 for one SIM of a gateway set up per line. It is the account name the gateway registers with, and it cannot be changed afterwards. Start a SIM’s name with the word set under “SIM lines are named”.",
    "number": "Number",
    "numberHelp": "The number a customer sees when a call leaves on this line. For a line per SIM it is also how an incoming call is matched to the line, so fill it in.",
    "kind": "Kind",
    "kindHelp": "A SIM carries one call at a time, so a caller is never left waiting on it.",
    "kinds": {
      "Sim": "SIM",
      "Trunk": "Trunk"
    },
    "address": "Address",
    "addressHelp": "Only for a gateway registered as one account for the whole box: its fixed address on the office network, because such a gateway sends the caller’s number where its own name should be. Leave empty for a line per SIM, and fill in the number instead: the gateway forwards each SIM’s calls to that SIM’s own number, and that is how the PBX tells them apart.",
    "byName": "by name",
    "dialPrefix": "Dial prefix",
    "dialPrefixHelp": "Only for a line per SIM: the gateway’s Routing Prefix for that line, put in front of every number dialled on it and stripped by the gateway. Without it such a gateway refuses the call, because it cannot tell which SIM it is for.",
    "password": "Password",
    "passwordHelp": "What the gateway registers with. Type the same into the gateway’s page. It is written to the PBX and kept nowhere else. Leave it empty for a trunk already set up in the telephone system’s own configuration: the PBX is asked whether it has a line of this name, and it is listed as it is.",
    "passwordKeepHelp": "Leave empty to keep the one the PBX has. Type a new one to replace it — the gateway stops registering until it is given the same.",
    "state": "Gateway",
    "registered": "Registered",
    "notRegistered": "Not registered",
    "inPbxConfiguration": "In the PBX’s configuration",
    "inPbxConfigurationHelp": "This line is set up in the telephone system’s own configuration, which holds how it connects. Here you change what the office calls it, its number, its kind and its prefix; nothing is written to the PBX.",
    "edit": "Edit",
    "editTitle": "Edit {{label}}",
    "remove": "Remove",
    "removeConfirm": "Remove {{label}} ({{name}})? It stops working at once. Calls that came in on it keep its name in the log.",
    "removeFromListConfirm": "Remove {{label}} ({{name}}) from the list? The telephone system keeps it, but it can no longer be chosen for calls out. Calls that came in on it keep its name in the log."
  },
  "deskPhones": {
    "title": "Desks and desk phones",
    "help": "A desk is a dispatcher’s place, with one or more handsets on it. Each handset takes one call, gets its own number from 7500, and shows its password once, to type into the phone. Whoever is at a desk has all its phones; the first free one rings. The order of the desks is the order calls reach them in.",
    "none": "No desks yet. Dispatchers answer in the browser.",
    "name": "Name",
    "nameHelp": "What the office calls it, like Desk 1.",
    "extension": "Number",
    "givenTo": "Given to",
    "atIt": "At it now",
    "state": "Phone",
    "nobody": "Nobody",
    "reachable": "Connected",
    "unreachable": "Not connected",
    "newPassword": "New password",
    "remove": "Remove",
    "removeConfirm": "Remove {{name}} ({{extension}})? It stops working at once, and the number is never given to another phone.",
    "typeIntoIt": "Type these into {{name}}",
    "typedIt": "I have typed them in",
    "shownOnce": "The password is shown only now. If it is lost, give the phone a new one.",
    "server": "Server",
    "serverUnset": "Set “Address desk phones register to” above",
    "userName": "User name",
    "password": "Password",
    "whereToType": "On a Yealink: its web page, Account → Register. The user name goes in Register Name and User Name both.",
    "notFetchedYet": "not fetched yet",
    "fetchedAt": "fetched {{when}}",
    "setUp": "Self-setup",
    "setUpTitle": "{{name}} sets itself up",
    "sendSettings": "Send settings now",
    "sent": "Sent. The phone downloads its settings within a few seconds, without restarting.",
    "mac": "MAC address",
    "macHelp": "From the label on the back of the phone. Leave empty to stop it setting itself up.",
    "noAddress": "This server has no address phones can reach it at. Your provider sets it.",
    "address": "Server URL",
    "whereToTypeAddress": "On a Yealink: its web page, Settings → Auto Provision → Server URL, then Save and Auto Provision Now. Nothing else needs typing: the phone downloads its account, a fresh password and the rest. The same address can be given to every phone at once by the office router — DHCP option 66.",
    "addDesk": "Add a desk",
    "addDeskHelp": "The desk gets its first phone now, under the same name.",
    "addPhone": "Add a phone",
    "addPhoneTitle": "Add a phone to {{desk}}",
    "phoneNameHelp": "What its screen shows, like {{desk}} · 2.",
    "noPhones": "No phones on this desk yet.",
    "desk": "Desk",
    "moveUp": "Up",
    "moveDown": "Down",
    "moveTo": "Desk",
    "renameDesk": "Rename",
    "renameDeskTitle": "Rename {{name}}",
    "removeDesk": "Remove desk",
    "removeDeskConfirm": "Remove the desk {{name}}? It has no phones on it, and whoever is at it is at no desk afterwards."
  },
  "pager": {
    "range": "{{first}}–{{last}} of {{total}}",
    "previous": "Previous",
    "next": "Next"
  },
  "counts": {
    "bookings_one": "{{shown}} booking",
    "bookings_other": "{{shown}} bookings",
    "destinations_one": "{{shown}} destination",
    "destinations_other": "{{shown}} destinations",
    "addresses_one": "{{shown}} address",
    "addresses_other": "{{shown}} addresses",
    "callers_one": "{{shown}} caller",
    "callers_other": "{{shown}} callers",
    "callersAddresses_one": "{{shown}} caller's address",
    "callersAddresses_other": "{{shown}} callers' addresses"
  },
  "layout": {
    "divider": "Divider between the working area and the map — drag, arrow keys, double-click restores the default width"
  },
  "whatsNew": {
    "title": "What's new",
    "releasedOn": "Released on {{date}}",
    "unread": "There is a new release — see what's new",
    "view": "How to read it",
    "viewBoard": "Board",
    "viewPage": "Page",
    "viewCards": "Cards",
    "atAGlance": "{{month}} at a glance",
    "previous": "Previous",
    "next": "Next",
    "cardOf": "{{at}} of {{total}}"
  },
  "form": {
    "enterANumber": "Type a number",
    "enterANumberFrom": "Type a number, at least {{min}}",
    "atLeast": "At least {{min}}",
    "atMost": "At most {{max}}",
    "tooPrecise": "Too many digits after the decimal point",
    "oneField": "Not saved. {{label}}: {{message}}",
    "severalFields_one": "Not saved. {{count}} field needs correcting, marked in red: {{labels}}",
    "severalFields_other": "Not saved. {{count}} fields need correcting, marked in red: {{labels}}"
  },
  "replay": {
    "keepTitle": "Keeping journeys",
    "keepHelp": "A journey is a record of where a driver was, minute by minute. It is kept this long after the order ends and then deleted, with the route its fare was measured on. A new value applies to journeys from now on, never to ones already kept.",
    "retentionDays": "Keep journeys for",
    "retentionDaysHelp": "Long enough for a complaint, an insurer and a slow police request. Half a year is usual.",
    "problemsTitle": "What counts as a problem",
    "problemsHelp": "The Journeys report flags a ride by these. Changing one re-reads every ride by the new rule; nothing that was recorded changes.",
    "lateMinutes": "Late arrival after",
    "lateMinutesHelp": "Minutes past the expected time: the time a pre-booking was booked for, or the router's time from where the driver took the order.",
    "detourPercent": "Long way round when longer by",
    "detourPercentHelp": "How much longer than the best route a ride may be, in percent of it.",
    "detourMinimumMetres": "…and by at least",
    "detourMinimumMetresHelp": "So a short hop that went round one block is not a detour because one block is a third of it.",
    "longWaitMinutes": "Long wait after",
    "longWaitMinutesHelp": "Minutes the car waited at the pickup for the client.",
    "longStopMinutes": "Stop on the way after",
    "longStopMinutesHelp": "Minutes standing still anywhere the order did not ask for — not the pickup, a stop or the drop-off.",
    "inTownSpeedKmh": "Speeding in town above",
    "inTownSpeedKmhHelp": "Inside the town you drew under Settings → Address search. With no town drawn, the whole ride is judged by this limit.",
    "outOfTownSpeedKmh": "Speeding out of town above",
    "outOfTownSpeedKmhHelp": "Every road outside the town, motorways included: the app cannot tell which road a car was on, only whether it was in town.",
    "unitPercent": "%",
    "unitKmh": "km/h"
  },
  "driverApp": {
    "groupTalk": "Talking to the office",
    "groupTalkHelp": "The two things a driver can send without ringing in.",
    "messagingEnabled": "Messages",
    "messagingEnabledHelp": "Drivers and the desk exchange short messages in the app, with ready phrases on both sides. Off, every word goes through the telephone.",
    "alarmEnabled": "Silent alarm",
    "alarmEnabledHelp": "A hidden button a driver holds down; every desk sees a red banner with the car, the number and the ride, and somebody clears it.",
    "groupOffers": "Who is offered what",
    "groupOffersHelp": "Two switches that change how dispatch chooses a car. Both start off.",
    "headingHomeEnabled": "Drivers say where they are going",
    "headingHomeEnabledHelp": "A driver picks an address on his phone — or his home, saved once, in one tap — and is offered only jobs whose destination takes him nearer. A job with no destination is not offered to him while he is.",
    "nextJobEnabled": "The next job before the current ends",
    "nextJobEnabledHelp": "A car with a passenger aboard and a few minutes left is treated as a car standing at its destination, and may be offered a job near it. The driver answers on the screen he is driving with.",
    "nextJobMinutesBeforeFree": "Minutes before the drop-off",
    "nextJobMinutesBeforeFreeHelp": "How close to dropping off a car must be before it may be offered the next job. Five is the last streets of a journey.",
    "groupStreet": "Passengers off the street",
    "groupStreetHelp": "Most rides start in the street or at a rank. With this on, they are rides like any other.",
    "streetRidesEnabled": "Drivers record passengers they take themselves",
    "streetRidesEnabledHelp": "One button on the driver's phone opens the ride with the passenger aboard: he stops being offered jobs, leaves the rank, the shift book counts the ride with his meter reading, and a passenger who gives a number finds the receipt in the passenger app. Off, a driver who takes one is on a break as far as the office can see.",
    "groupShows": "What the phone shows",
    "groupShowsHelp": "What a driver sees beyond his own shift and his jobs.",
    "heatmapEnabled": "Heatmap",
    "heatmapEnabledHelp": "Where the work is: your zones with the orders waiting and the cars in each. Counts only, never where a colleague is.",
    "ratePassengersEnabled": "Rate the passenger",
    "ratePassengersEnabledHelp": "After a ride the driver is asked for a score and a word, which the screen-pop shows beside the number the next time it rings.",
    "showFares": "Show fares",
    "showFaresHelp": "The estimate on the offer and on the ride, and the computed fare beside the meter reading at the end. The meter in the car remains what the passenger pays.",
    "taximeterEnabled": "Taximeter on the phone",
    "taximeterEnabledHelp": "With a passenger aboard the phone counts time and distance and shows a running fare at your tariff, marked as indicative. The sealed meter in the car remains the authority.",
    "groupPlaces": "The firm's addresses",
    "groupPlacesHelp": "Drivers help place the entrances the map does not have.",
    "rememberEntrancesEnabled": "Remember entrances at the door",
    "rememberEntrancesEnabledHelp": "When a ride names an entrance nobody has placed, the driver is asked at the door whether to remember the spot, and a placed spot can be reported as wrong. The spot is saved once the passenger is in the car, and waits for the administrator's approval.",
    "groupDevices": "Easy sign-in",
    "groupDevicesHelp": "The driver signs in with no email or password — on a company device, or on his own phone, registered once by the office. Company devices are registered and handed out from Devices; a driver's own phone is added from Fleet → the driver → Devices, with a QR code.",
    "serviceDeviceRequestsEnabled": "A phone may ask for easy sign-in",
    "serviceDeviceRequestsEnabledHelp": "Under Easy sign-in, the driver app has a Send a registration request button. The phone shows a four-digit code, and the administrator is told with the same code. They pick or create the driver and the car, and approve — the phone becomes the driver's own. Off — a driver's own phone is added only with the QR code from the driver's dialog."
  },
  "messages": {
    "title": "Messages",
    "unread_one": "{{count}} new message",
    "unread_other": "{{count}} new messages",
    "unreadHint": "Words from the drivers nobody has read. Opens the desk.",
    "writeTo": "Write to…",
    "empty": "No driver has written yet. Pick one to write to.",
    "nothingYet": "Nothing yet.",
    "close": "Close",
    "send": "Send",
    "read": "read",
    "placeholder": "Write to the driver… Enter sends.",
    "sendFailed": "The message could not be sent. Try again.",
    "presets": "Ready phrases"
  },
  "alarms": {
    "raised": "{{driver}} raised the alarm at {{time}}",
    "noPhone": "no number on file",
    "onOrder": "on {{reference}}",
    "showOnMap": "Show on map",
    "clear": "Clear"
  },
  "places": {
    "building": "Address",
    "buildingHelp": "As it is said, without the entrance: Студентска 14, or ж.к. Дружба 3, бл. 12.",
    "entrance": "Entrance",
    "note": "Note for the dispatcher and the driver",
    "noteHelp": "What to know there: the entrance is from the yard, the bell does not work.",
    "names": "Other names",
    "namesHelp": "Separated by commas: Автогарата, сива кооп. Each one finds the place.",
    "add": "Add",
    "export": "Download CSV",
    "saved": "{{line}} saved.",
    "deleted": "Address removed.",
    "openExisting": "Open it",
    "confirmRemoveTitle": "Remove this address?",
    "confirmRemove": "{{line}} leaves every search, and its history with it. Orders already taken to it keep it.",
    "notice_one": "{{count}} address is waiting for your approval.",
    "notice_other": "{{count}} addresses are waiting for your approval.",
    "noticeOpen": "Review",
    "noticeLater": "Later",
    "source": {
      "administrator": "Administrator",
      "dispatcher": "Dispatcher",
      "driver": "Driver"
    },
    "map": {
      "door": "Door",
      "stop": "Where the car stops",
      "clickDoor": "Click the map where the door is.",
      "clickStop": "Click the map where the car should stop."
    },
    "lock": {
      "open": "Lock…",
      "move": "Move…",
      "title": "Lock the address",
      "moveTitle": "Move the address",
      "about": "Place this entrance on the map, and every search finds it from now on — the desk, the passenger app and the drivers.",
      "moveAbout": "Move the door of this address. Its note and names stay as they are.",
      "clickTheDoor": "Click the map where the door is.",
      "noPoint": "Choose the address from the list first, so the map knows where to open.",
      "save": "Lock",
      "useIt": "Use that one",
      "moveHere": "Move it here"
    },
    "settings": {
      "title": "Who places addresses",
      "dispatchers": "Dispatchers lock addresses",
      "dispatchersHelp": "A dispatcher may place an address from the order, and move one. It is used at once and waits for your approval; deleting is yours alone.",
      "entrances": "How the desk offers entrances",
      "entrancesHelp": "In the list, each entrance is a row. After the address, the building is one row and its letters appear once it is chosen. Each dispatcher may choose the other way for themselves."
    },
    "review": {
      "title_one": "{{count}} waiting for approval",
      "title_other": "{{count}} waiting for approval",
      "about": "Placed or changed by a dispatcher or a driver, and used already. Approving keeps it; rejecting undoes it. A driver's report moves nothing until you agree.",
      "added": "New",
      "changed": "Changed",
      "reported": "Driver: wrong spot",
      "reportSpot": "The passenger got in {{metres}} m away.",
      "reportNoSpot": "The passenger did not come; no spot was given.",
      "before": "Where it was",
      "show": "Show",
      "approve": "Approve",
      "reject": "Reject",
      "moveThere": "Move it there",
      "keep": "Leave it",
      "close": "Seen",
      "approved": "Done.",
      "rejected": "Undone."
    },
    "change": {
      "placed": "Placed.",
      "moved": "Moved {{metres}} m",
      "renamed": "now {{line}}",
      "note": "note changed",
      "names": "names changed",
      "stop": "stop changed",
      "nothing": "Nothing changed."
    },
    "history": {
      "title": "History",
      "added": "Placed",
      "changed": "Changed",
      "reported": "Reported as wrong",
      "restored": "Put back",
      "reportedSpot": "With the spot where the passenger got in.",
      "answered": "answered by {{name}} {{at}}",
      "restore": "Put this back",
      "state": {
        "waiting": "waiting",
        "approved": "approved",
        "rejected": "rejected"
      }
    },
    "editor": {
      "addTitle": "Add an address",
      "editTitle": "Change the address",
      "find": "Find the building",
      "findHelp": "The map opens on it; then click each door.",
      "findButton": "Find",
      "nothingFound": "Nothing found.",
      "clickSets": "A click on the map sets",
      "doorSet": "The door is placed.",
      "doorMissing": "Click the map where the door is.",
      "stopSet": "The car stops elsewhere.",
      "stopAtDoor": "The car stops at the door.",
      "stopClear": "Stop at the door",
      "next": "Next entrance",
      "delete": "Delete"
    },
    "list": {
      "title_one": "{{count}} address",
      "title_other": "{{count}} addresses",
      "filter": "Filter by address or name",
      "empty": "No addresses yet. Add the first, or let the drivers save them at the door.",
      "noMatch": "Nothing matches.",
      "placedBy": "Placed by"
    },
    "import": {
      "open": "Upload CSV",
      "title": "Upload addresses",
      "about": "A CSV with at least the address and the longitude and latitude of the door — the shape Download CSV gives. Nothing is saved until you add the new rows; an address already here is never written over.",
      "row": "Row",
      "status": "",
      "new": "new",
      "conflict": "already here",
      "invalid": "cannot be read",
      "add_one": "Add {{count}} new",
      "add_other": "Add {{count}} new",
      "done_one": "{{count}} address added.",
      "done_other": "{{count}} addresses added.",
      "noPoint": "The longitude and latitude cannot be read — numbers with a point, like 27.9147 and 43.2141.",
      "fileHint": "CSV, as Export CSV gives it",
      "joinSimilar": "Join similar addresses",
      "joinSimilarHelp": "Off: only an address written with the same words counts as already here. On: one whose words are inside another's — Бряст and завод Бряст — counts as the same, and is not added. An address at the back — зад, отзад — is never the same as the front."
    },
    "google": {
      "why": "Google named this address. Before it is locked as the firm’s own:",
      "name": "write it your own way",
      "pin": "move the pin to the exact door"
    },
    "backToReport": "Back to the report",
    "alsoJoin": "Also join {{orders}} and {{addresses}} of “{{line}}”",
    "joinExisting": "Join to it",
    "joinedAfterSave": "Locked “{{line}}”; joined {{orders}} and {{addresses}}.",
    "joins": {
      "title": "Joins",
      "pending": "Incomplete",
      "finish": "Finish",
      "undo": "Undo",
      "undone": "undone",
      "entry": "“{{typed}}”: {{orders}}, {{destinations}}, {{addresses}}",
      "finished": "The join was finished.",
      "undoneNotice": "The join was undone.",
      "row": "Joined from the report",
      "undoneBy": "undone by {{name}} {{at}}"
    }
  },
  "labels": {
    "title": "Labels",
    "help": "A dispatcher ticks a label on an order, a passenger can ask for one in the app, and the order is offered only to a car that has it. A label is switched off rather than deleted, because cars and past orders still name it.",
    "add": "Add a label",
    "none": "This firm has no labels yet.",
    "picture": "Picture",
    "name": "Name",
    "shownToRiders": "In the passenger app",
    "shownToRidersOf": "Show “{{name}}” in the passenger app",
    "shownToRidersHelp": "Passengers can ask for it in the app. Leave it off for a label only the office should set.",
    "active": "In use",
    "activeOf": "“{{name}}” in use",
    "order": "Order",
    "edit": "Edit",
    "editTitle": "{{name}}",
    "translated": "Shown in each reader’s language until you rename it",
    "nameHelp": "As the dispatcher and the passenger will read it.",
    "nameStarterHelp": "A ready-made label says itself in each reader’s language. Typing other words renames it, and then everybody reads your words.",
    "pictureAfterAdding": "Once the label is added you can give it a picture.",
    "pictureHelp": "PNG, JPEG or WebP, up to {{kb}} KB. Square works best. Without a picture the label is shown in words alone.",
    "choosePicture": "Choose a picture…",
    "replacePicture": "Replace the picture…",
    "removePicture": "Remove the picture",
    "defaultPicture": "Back to the default picture",
    "wordsAlone": "Words alone",
    "defaultMark": "default",
    "switchedOff": "switched off",
    "switchedOffHelp": "“{{name}}” is switched off. It is shown only because it is ticked, so it can be unticked."
  },
  "cancellations": {
    "title": "Reasons",
    "help": "After Cancel, the passenger app offers the reasons switched on here, in this order, then asks the passenger to confirm. The one chosen is written in the order’s history. A reason is switched off rather than deleted, because past orders still name it.",
    "add": "Add a reason",
    "none": "This firm has no cancellation reasons yet.",
    "name": "Reason",
    "active": "Offered",
    "activeOf": "Offer “{{name}}”",
    "order": "Order",
    "rename": "Rename",
    "renameTitle": "Rename “{{name}}”",
    "translated": "Shown in each reader’s language until you rename it",
    "nameHelp": "As the passenger will read it, in a few words.",
    "nameStarterHelp": "A ready-made reason says itself in each reader’s language. Typing other words renames it, and then everybody reads your words."
  },
  "fileDrop": {
    "drop": "Drop the file here",
    "release": "Let go to take this file",
    "or": "or",
    "choose": "choose one from your computer",
    "another": "choose another",
    "size": "{{size}} KB"
  },
  "devices": {
    "row": "Devices",
    "label": "Number",
    "labelHelp": "As written on its sticker, for example \"T-07\". It is how the device is found in the list and in the drawer.",
    "kind": {
      "Phone": "Phone",
      "Tablet": "Tablet"
    },
    "retirement": {
      "Broken": "Broken",
      "Stolen": "Stolen",
      "Lost": "Lost"
    },
    "list": {
      "title": "Easy sign-in devices",
      "help": "A company device is registered here and only here. It stays here: you give it to a driver, take it back and give it to the next, until you write it off. A driver's own phone is his alone — add it from Fleet → the driver's Devices or by approving a request.",
      "register": "Register a company device",
      "registerTitle": "New company device",
      "registerHelp": "Give it a number, then show the QR code. Scan it from the app on the device: \"Easy sign-in\" → \"Scan the office's QR code\". The device stays free until you give it to a driver.",
      "showQr": "Show the QR code",
      "kindFilter": "Kind",
      "allKinds": "All",
      "phones": "Phones",
      "tablets": "Tablets",
      "statusFilter": "State",
      "all": "All",
      "inUse": "In use",
      "free": "Free",
      "freeOne": "Free",
      "retired": "Written off",
      "none": "No devices yet. Register the first company device with a QR code.",
      "noneHere": "No devices match these filters.",
      "kind": "Kind",
      "kindHelp": "The app tells by the size of its screen. Correct it if it got it wrong.",
      "model": "Model",
      "state": "State",
      "lastUsed": "Last signed in",
      "never": "Not yet",
      "give": "Give to…",
      "giveTitle": "Give {{device}} to a driver",
      "giveHelp": "The device signs in as this driver by itself within a few seconds. No QR code: it is already the company's.",
      "editTitle": "Edit {{device}}",
      "retire": "Write off",
      "retireTitle": "Writing off {{device}}",
      "why": "Why",
      "retireHelp": "The device stops at once and can never sign in again. It stays under \"Written off\", for the record.",
      "retireHelpInUse": "{{name}} is signed out of it at once. The device can never sign in again and stays under \"Written off\", for the record.",
      "retiredOn": "written off {{date}}",
      "lastWith": "last with {{name}}",
      "delete": "Delete",
      "deleteTitle": "Delete this device?",
      "deleteHelp": "{{device}} leaves the list, with its history. Registered again, it starts as a new one.",
      "ownerFilter": "Whose",
      "allOwners": "All",
      "firms": "Company",
      "personals": "Own"
    },
    "unnamed": "Unnamed phone",
    "close": "Close",
    "couldNotLoad": "The devices could not be loaded.",
    "couldNotSave": "The change was not saved.",
    "banner": {
      "asked": "Easy sign-in request — code {{code}}",
      "open": "Open"
    },
    "approve": {
      "title": "Easy sign-in request",
      "asked": "asked at {{time}}",
      "matchCode": "Check the same code is on the phone's screen, or have the driver read it to you over the phone.",
      "whose": "Whose phone",
      "existingDriver": "A driver on the list",
      "newDriver": "New driver",
      "driver": "Driver",
      "pickDriver": "Choose a driver",
      "whichCar": "Car",
      "existingCar": "A car on the list",
      "newCar": "New car",
      "noCar": "No car",
      "car": "Car",
      "carHelp": "Added to the cars this driver may drive. The others stay.",
      "pickCar": "Choose a car",
      "approve": "Approve",
      "reject": "Turn down",
      "personalHelp": "The phone becomes the driver's own: it signs only them in and cannot be given to anybody else. Company devices are registered from Devices."
    },
    "dialog": {
      "title": "{{name}}'s devices",
      "how": "How they sign in",
      "managed": "The office manages the account",
      "managedHelp": "The driver signs in by easy sign-in — a QR code or a request from the phone, with no email or password. On — every other session of the driver ends at once.",
      "alternate": "May use several devices, one at a time",
      "alternateOn": "Any of their devices may work. When the driver taps \"Work from this phone\", the other one stops.",
      "alternateOff": "One device only. A new one replaces the old, and the old one stops.",
      "phones": "Devices",
      "noPhones": "No device yet. Give them a company device, or add their own phone with a QR code.",
      "addPhone": "Add their own phone with a QR code",
      "neverUsed": "approved {{date}}, not signed in yet",
      "lastUsed": "last signed in {{date}}",
      "release": "Free it",
      "confirmReleaseTitle": "Free this device?",
      "confirmRelease": "{{device}} goes back to the company, free. {{name}} is signed out of it at once. Then give it to another driver from Devices.",
      "giveFree": "Give a company device",
      "give": "Give",
      "keep": "Keep it",
      "replaces": "The driver may have one device only: the new one replaces this one. A company device becomes free; their own phone is forgotten.",
      "remove": "Remove",
      "confirmRemoveTitle": "Remove their own phone?",
      "confirmRemove": "{{name}} is signed out of {{device}} at once, and the phone is forgotten. To sign in from it again, add it again with a QR code or a request."
    },
    "qr": {
      "alt": "QR code for the driver's own phone",
      "help": "In the driver app: Easy sign-in → Scan the office's QR code. The code lasts 15 minutes, for one phone.",
      "scanned": "The phone is registered and the driver is signed in.",
      "lapsed": "The code has lapsed.",
      "again": "New code",
      "couldNotIssue": "The QR code could not be made.",
      "registered": "The device is registered and free. Give it to a driver from the list."
    },
    "hire": {
      "how": "How they sign in",
      "byEmail": "Email and password",
      "byDevice": "Easy sign-in",
      "byDeviceHelp": "No email. Once you save, you will see a QR code for their own phone. A company device you give them with \"Give a company device\".",
      "done": "{{name}} is hired. Scan the QR code with their phone."
    },
    "owner": {
      "firm": "Company",
      "personal": "Own"
    }
  }
}
